/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useContext } from "react";
import {
    FormControl,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography,
    InputLabel
} from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { createStyles } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import {
    AnnounceInputs,
    IAddress,
    IEquipment,
    IPropertyType,
    PropertyInputs,
} from "../../utils/AnnounceInterfaces";
import { useTranslation } from "react-i18next";
import { ISnackbar } from "../../utils/enum/snackBarType";
import { colors } from "../../styles/defaultColors";
import {
    equipmentsDefaultValue,
    propertyTypesDefaultValue,
    propertyInputsDefaultValue,
    addressDefaultValue,
    announceInputsDefaultValue,
} from "../../utils/defaultNullValues";
import SessionHandler from "../../https/SessionHandler";
import { PropertyService } from "./services/PropertyService";
import { UserContext } from "../../contexts/AppContext";
import { useHistory, useParams } from "react-router";
import { Error } from "@material-ui/icons";
import { Button } from "@material-ui/core";
// import countryList from 'react-select-country-list';
import Spin from "../../images/Spin";
import { AfriqSnackbar } from "../components/OverridingMaterial/AfriqSnackbar";
import { UploadPhotos } from "./components/UploadPhotos";
import { AutoCompleteWithChipsProperty } from "./components/AutoCompleteWithChipsProperty";
import { DescriptionRichText } from "../components/DescriptionRichText";
import {
    EAddressErrorMessages,
    EAnnounceErrorMessages,
    EPropertyErrorMessages,
    ERsttErrorMessages,
    EVehicleErrorMessages,
} from "../../utils/enum/properties";
import { PreviewPhotos } from "./components/PreviewPhotos/PreviewPhotos";
import { CircularProgress } from "@mui/material";
import { CountryService } from "../Admin/Countries/services/EquipmentCountry";
import { EquipmentService } from "../Admin/Equipments/services/EquipmentService";
import { PropertyTextFieldMulitline } from "./components/PropertyTextFieldMulitline";
import { paymentMethodList, paymentMethodMobileList } from "../../utils/App";
import AutoCompleteWithChipsPayement from "./AutoCompleteChipsPayement";
import { EPaymentMethod } from "../../utils/enum/PaymentMethod";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { SelectEndornmentNationPolitique } from "./components/FormSteps/SelectAnulation";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import moment from "moment";
import { CountryPhoneList } from "../../utils/CountryList";
import { SelectEndornmentNationPolitiqueNoremb } from "./components/FormSteps/SelectNoremboursable";
import { IEquipmentCategory } from "../../utils/AnnounceInterfaces";
import { CheckableTreeItem } from "../../utils/checkableTreeItem";
import { IVille } from "../../utils/DiversInterfaces";
import { villeDefaultValue } from "../../utils/defaultNullValues";
import { IPays } from "../../utils/DiversInterfaces";
import { SortArray } from "../../utils/App";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        editContainer: {
            background: "#ffffff", //03265 061 29
            paddingTop: 27,
            paddingBottom: 27,
        },
        photosContainer: {},
        propertyInfosContainer: {},
        "@global": {
            ".rc-time-picker": {
                width: "100%",
            },
            ".rc-time-picker-input": {
                height: 60,
                fontSize: 17,
            },
        },

        button: {
            background: "#890608",
            color: "white",
            borderRadius: 100,
            fontFamily: "Josefin Sans",
            fontSize: 14,
            textTransform: "none",
            padding: "8px 14px",
            marginLeft: 20,
            "&:hover": {
                background: "#B5551B",
            },
        },
        category: {
            marginTop: 10,
            fontSize: "initial",
        },
        inpuText: {
            marginBottom: 14,
            marginTop: 6
        },
        updateInfosButtonsContainer: {
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            alignItems: "center",
        },
        updateButton: {
            borderRadius: 100,
            textTransform: "none",
            fontSize: 14,
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2),
            textAlign: "center",
            fontFamily: "Josefin Sans",
            background: "#AAAAAA",
            color: "#ffffff",
            padding: "8px 14px",
            "&:hover": {
                background: "#B5551B",
            },
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },
        annuler: {
            lineHeight: "30px",
        },
        label: {
            fontFamily: "Josefin Sans",
            fontSize: 16,
            color: "#000000",
        },
        editor: {
            border: "1px solid gray",
            minHeight: "400px",
            marginTop: theme.spacing(5),
        },
        propertiesTitle: {
            fontSize: 22,
            fontFamily: "Josefin Sans",
            color: "#890608",
            marginTop: 40,
            textAlign: "center",
            marginBottom: 27,
        },

        announcePriceContainer: {
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
        },

        announcePriceItem: {
            flex: 0.47,
        },
    })
);
const countryService = new CountryService();
const propertyService = new PropertyService();
const equipmentService = new EquipmentService();
export const EditProperty = () => {
    const sessionHandler = React.useMemo(() => new SessionHandler(), []);
    const isConnected = sessionHandler.isConnected;
    const userContext = useContext(UserContext);
    const { user, setUser } = userContext;
    const history = useHistory();
    const params: { id: string } = useParams();
    const classes = styles();
    const { t, i18n } = useTranslation();
    let errors: string[] = [];
    const [errorMessages, setErrorMessages] = React.useState<string>("");
    const [snackValues, setSnackValues] = React.useState<ISnackbar>({
        type: "success",
        open: false,
        message: "",
    });

    const [announce, setAnnounce] = React.useState<AnnounceInputs>({
        ...announceInputsDefaultValue,
        owner: user._id || "",
    });
    const [oldAnnounce, setOldAnnounce] = React.useState<AnnounceInputs>({
        ...announceInputsDefaultValue,
        owner: user._id || "",
    });

    const [property, setProperty] = React.useState<PropertyInputs>(
        propertyInputsDefaultValue
    );
    const [oldProperty, setOldProperty] = React.useState<PropertyInputs>(
        propertyInputsDefaultValue
    );
    const [address, setAddress] = React.useState<IAddress>(addressDefaultValue);
    const [oldAddress, setOldAddress] =
        React.useState<IAddress>(addressDefaultValue);
    const [propertyTypeList, setPropertyTypeList] = React.useState<
        IPropertyType[]
    >(propertyTypesDefaultValue);
    const [equipmentsList, setEquipmentsList] = React.useState<IEquipment[]>(
        equipmentsDefaultValue
    );
    const [equipmentsSelected, setEquipmentsSelected] = React.useState<
        IEquipment[]
    >([]);
    const [oldEquipmentsSelected, setOldEquipmentsSelected] = React.useState<
        IEquipment[]
    >([]);
    const [newPhotos, setNewPhotos] = React.useState<any>([]);
    // const options = useMemo(() => countryList().getData(), []);
    const [previewPhotos, setPreviewPhotos] = React.useState<any>([]);
    const [paymentSelected, setPayementSelected] = React.useState<any>([]);
    const [loadingPage, setLoadingPage] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [isUpdating, setIsUpdating] = React.useState(false);
    const [paysList, setPaysList] = React.useState<IPays[]>([]);
    const [villeSelected, setVilleSelected] = React.useState<any>([]);
    const [city, setVille] = React.useState<IVille>(villeDefaultValue);
    const [payment, setPayment] = React.useState([]);
    const [selectedPaymentMethod, setSelectedPaymentMethod] =
        React.useState<any>([]);
    const [rank, setRank] = React.useState(false);
    const [animals, setRankAnimals] = React.useState(false);
    const [childs, setRankChilds] = React.useState(false);
    const [checkin, setDispatchTime] = React.useState(moment());
    const [checkout, setDispatchTimeOut] = React.useState(moment());
    const [devise, setDevise] = React.useState("");
    const [codeNum, setCodeNum] = React.useState("");
    const [priceWeeklyDaily, setPriceWeeklyDaily] = React.useState<number>(0);
    const [priceBiWeeklyDaily, setPriceBiWeeklyDaily] =
        React.useState<number>(0);
    const [priceMonthlyDaily, setPriceMonthlyDaily] = React.useState<number>(0);
    const [valueGroup, setValueGroup] = React.useState("");
    const [categorie, setCategorie] = React.useState<any>([]);
    const [filteredCities, setFilteredCities] = React.useState<IVille[]>([]);

    const handleChangeGroup = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValueGroup((event.target as HTMLInputElement).value);
        setAnnounce({
            ...announce,
            remboursable: (event.target as HTMLInputElement).value,
        });
    };
    const SearchTypeName = property.type?.searchType?.name; 
    function SortArray1(x : any,y : any){
        if(x.category.name < y.category.name){return -1;}
        if(x.category.name > y.category.name){return 1;}
        return 0;
    }
    /*****************choix remboursable */
    React.useEffect(() => {
        if (valueGroup === "noremboursable") {
            setAnnounce({
                ...announce,
                freeRefundDay: 0,
                penaltyDayFees: 0,
                penaltyDayFeesAfterBookingStarted: 0,
            });
        } else if (valueGroup === "remboursable") {
            setAnnounce({
                ...announce,
                notRemboursable1: 0,
            });
        }
    }, [valueGroup]);
    /*******************************fin ici***********************/
    const handleValueChange = (value: any) => {
        setDispatchTime(value);
    };

    const handleValueChangeOut = (value: any) => {
        setDispatchTimeOut(value);
    };
    

const invalidCity: IVille = {
        _id: '', // Default empty ID
        count: '0', // Placeholder count
        name: 'Invalid City', // Default name
        nomFR: 'Ville invalide', // Optional
        nomEN: 'Invalid City', // Optional
        quartiers: [], // Optional
    };

    const invalidCountry: IPays = {
        _id: '', // Default or placeholder ID
        name: 'Invalid Country', // Placeholder name
        nomFR: 'Pays invalide', // Placeholder French name
        nomEN: 'Invalid Country', // Placeholder English name
        status: false, // Default status
        currencyCode: '', // Placeholder currency code
        villes: [], // Empty array for cities
        // Optional fields can be left undefined or filled with placeholders if necessary
        photo: undefined,
        countryId: undefined,
        registeredTaxName: undefined,
        taxReference: undefined,
        businessType: undefined,
        postalAdress: undefined,
        officeNumbers: undefined,
        phoneCode: undefined
    };

    React.useEffect(() => {
        countryService.getAllCountries().then((response) => {
            if (response.success) {
                if (response.data !== undefined) {
                    setPaysList(response.data.sort(SortArray));
                }
            }
        });
    }, [setPaysList]);

   
    React.useEffect(() => {
        if (address.country?._id) {
            const selectedCountry = paysList.find(
                (country: IPays) => country._id === address.country?._id
            );
            if (selectedCountry) {
                setDevise(selectedCountry.currencyCode || ""); // Ensure currencyCode is a string
                setCodeNum(selectedCountry.phoneCode || ""); // Ensure phoneCode is a string
                setFilteredCities(selectedCountry.villes || []); // Handle empty or undefined cities
            } else {
                // If the country is not found or has no cities
                setFilteredCities([]);
                setDevise("");
                setCodeNum("");
            }
        }
    }, [address.country, paysList]);

    React.useEffect(() => {
        if (address.city?._id) {
            const existingCity = filteredCities.find(
                (city: IVille) => city._id === address.city?._id
            );
            if (!existingCity) {
                setAddress((prevAddress) => ({
                    ...prevAddress,
                    city: invalidCity, // Clear invalid city
                }));
            }
        }
    }, [address.city, filteredCities]);
    
    React.useEffect(() => {
        setAnnounce({
            ...announce,
            devise: devise,
            checkin: checkin,
            checkout: checkout,
        });
    }, [checkin, checkout, address]);

    React.useEffect(() => {
        setAddress({
            ...address,
            city,
        });
    }, [city]);

    React.useEffect(() => {
        setAnnounce({
            ...announce,
            animaux: animals,
            enfant: childs,
            fetes: rank,
        });
    }, [rank, animals, childs]);
    
    React.useEffect(() => {
        if (!user.email) {
            isConnected()
                .then((response: any) => {
                    if (response.success) {
                        setUser(response.data);
                    }
                })
                .catch((err) => {
                    history.push("/");
                });
        } else {
            setLoadingPage(true);
            Promise.all([
                propertyService.getAllPropertyTypes(),
                propertyService.getAllEquipments(),
                propertyService.getAnnounceByIdAdm(params.id),
            ]).then(([resAllPropertyTypes, resAllEquipments, resAnnounce]) => {
                if (resAllPropertyTypes.success) {
                    // Filter property types by searchType.name matching SearchTypeName
                    const filteredPropertyTypes = resAllPropertyTypes.data.filter(
                        (propertyType: IPropertyType) => propertyType.searchType?.name === SearchTypeName
                    );
                    setPropertyTypeList(filteredPropertyTypes);
                }

                if (resAllEquipments.success) {
                    // Filter equipments based on SearchTypeName
                    const filteredEquipments = resAllEquipments.data.filter(
                        (equipment: IEquipment) =>
                            equipment.applicableSearchTypes?.includes(SearchTypeName || '')
                    );
                    setEquipmentsList(filteredEquipments.sort(SortArray1));
                }

                if (resAnnounce.success) {
                    //    setSelectedPaymentMethod(resAnnounce.data.paymentMethod.map((meth:any)=>meth))
                    setAnnounce(resAnnounce.data);
                    setValueGroup(
                        resAnnounce.data.remboursable === undefined
                            ? "remboursable"
                            : resAnnounce?.data?.remboursable
                    );
                    setOldAnnounce(resAnnounce.data);
                    setProperty({
                        ...resAnnounce.data.property,
                        type: resAnnounce.data.property.type,
                    });

                    setPreviewPhotos(
                        resAnnounce.data.property.photos.map((photo: any) => {
                            if (photo.fileURL) {
                                return {
                                    id: photo._id,
                                    url: photo.fileURL,
                                    filename: photo.filename,
                                };
                            }
                            return {
                                id: photo._id,
                                url: "",
                            };
                        })
                    );

                    setOldProperty({
                        ...resAnnounce.data.property,
                        type: resAnnounce.data.property.type,
                    });
                    setAddress(resAnnounce.data.property.address);
                    setOldAddress(resAnnounce.data.property.address);
                    setRank(resAnnounce.data.fetes);
                    setRankAnimals(resAnnounce.data.animaux);
                    setDispatchTime(moment(resAnnounce.data.checkin));
                    setDispatchTimeOut(moment(resAnnounce.data.checkout));
                    setRankChilds(resAnnounce.data.enfant);
                    setEquipmentsSelected(
                        resAnnounce.data.property?.equipments
                    );
                    setOldEquipmentsSelected(
                        resAnnounce.data.property?.equipments
                    );
                    setPriceWeeklyDaily(
                        Number(
                            (resAnnounce.data.priceWeekly / 7).toFixed(
                                devise?.toUpperCase() === "XAF" ? 0 : 2
                            )
                        ) ?? 0
                    );
                    setPriceBiWeeklyDaily(
                        Number(
                            (resAnnounce.data.priceBiWeekly / 14).toFixed(
                                devise?.toUpperCase() === "XAF" ? 0 : 2
                            )
                        ) ?? 0
                    );
                    setPriceMonthlyDaily(
                        Number(
                            (resAnnounce.data.priceMonthly / 30).toFixed(
                                devise?.toUpperCase() === "XAF" ? 0 : 2
                            )
                        ) ?? 0
                    );
                }
                setLoadingPage(false);
            });
        }
    }, [
        user,
        history,
        isConnected,
        setUser,
        setEquipmentsList,
        params.id,
        devise,
    ]);

    React.useEffect(() => {
        //console.log("Fetching all categories...");
        setLoading(true);
    
        if (!SearchTypeName) {
            // If SearchTypeName is undefined, skip the API call
            setCategorie([]);
            setLoading(false);
            return;
        }
    
        equipmentService.getAllCategories()
            .then(response => {
                if (response.success) {
                    // Filter categories based on SearchTypeName
                    const filteredCategories = response.data.filter(
                        (category: IEquipmentCategory) => 
                            category.applicableSearchTypes?.includes(SearchTypeName)
                    );
                    
                    //console.log("Filtered Categories:", filteredCategories); // Log filtered categories
                    setCategorie(filteredCategories);
                    
                }
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching categories:", error);
                setLoading(false);
            });
    }, [SearchTypeName]); // Only re-run effect when SearchTypeName changes

    React.useEffect(() => {
        setProperty({
            ...property,
            address,
        });
    }, [address]);
    // console.log("detailail annnnn",moment(announce.checkin))



    // Build the equipment list by category
    let tab_eq: any = [];
    categorie?.forEach((catego: any) => {
        const eqmt = equipmentsList?.filter(eq => eq.category?._id === catego._id);
        if (eqmt && eqmt.length > 0) {
            tab_eq.push({
                categorie: catego.name[i18n.language as 'en' | 'fr'] || "Unknown",
                equipement: eqmt,
            });
        }
    });
    //console.log("tab_eq structure:", tab_eq);

    const onChangeEquipments = (value: IEquipment[]): void => {
        setEquipmentsSelected(value);

        const ids: string[] = value.map((value: any) => value._id);
        setProperty({
            ...property,
            equipments: ids,
        });
    };

    const handleCheck = (eq: IEquipment) => {
        // Toggle the equipment selection
        setEquipmentsSelected((prevSelected) => {
            const isAlreadySelected = prevSelected.some((el: IEquipment) => el._id === eq._id);
            
            // Update selected equipments based on the toggle state
            const updatedEquipments = isAlreadySelected 
                ? prevSelected.filter((el: IEquipment) => el._id !== eq._id) // Remove if already selected
                : [...prevSelected, eq]; // Add if not already selected
    
            // Update property.equipments to store the equipment IDs
            setProperty((prevProperty) => ({
                ...prevProperty,
                // Filter out undefined values from the equipment IDs
                equipments: updatedEquipments
                    .map((item) => item._id)
                    .filter((id): id is string => id !== undefined), // Ensure we only keep defined strings
            }));

            //console.log("Selected Equipments:", updatedEquipments); // After updating equipmentsSelected
            //console.log("Property Equipments:", updatedEquipments.map((item) => item._id)); // After updating property.equipments
    
            return updatedEquipments; // Update state for the selected equipment list
        });
    };
       



    const onChangePayement = (values: any) => {
        setPayementSelected(values);
    };

    const onChangeHandler = (event: any): void => {
        setProperty({
            ...property,
            [event.target.name]: event.target.value,
        });
    };

    const onChangeAnnonce = (event: any): void => {
        setAnnounce({
            ...announce,
            [event.target.name]: event.target.value,
        });
    };

    const onChangeAddress = (event: any): void => {
        setAddress({ ...address, [event.target.name]: event.target.value });
    };
    const onChangePropertyTypeHandler = (event: React.ChangeEvent<{ value: unknown }>) => {
        const selectedTypeId = event.target.value as string;
        const selectedType = propertyTypeList.find((type) => type._id === selectedTypeId);
    
        if (selectedType) {
            setProperty({
                ...property,
                type: selectedType,  // Set the entire property type object, not just the _id
            });
        }
    };
    // Update the country change handler
    const onChangePropertyPaysHandler = (event: React.ChangeEvent<{ value: unknown }>): void => {
        const selectedCountryName = event.target.value as string;
    
        const selectedCountry = paysList?.find(
            (country: IPays) =>
                (i18n.language === "fr" ? country.nomFR : country.nomEN) === selectedCountryName
        );
    
        if (selectedCountry) {
            setAddress((prevAddress) => ({
                ...prevAddress,
                country: selectedCountry,
                city: invalidCity, // Clear city when country changes
            }));
    
            setFilteredCities(selectedCountry.villes || []);
        } else {
            setAddress((prevAddress) => ({
                ...prevAddress,
                country: invalidCountry,
                city: invalidCity,
            }));
    
            setFilteredCities([]);
        }
    };
    

    // Update the city change handler
    const onChangePropertyVilleHandler = (event: React.ChangeEvent<{ value: unknown }>) => {
        const selectedCityName = event.target.value as string;
    
        const selectedCity = filteredCities.find(
            (city: IVille) =>
                (i18n.language === "fr" ? city.nomFR : city.nomEN) === selectedCityName
        );
    
        setAddress((prevAddress) => ({
            ...prevAddress,
            city: selectedCity || invalidCity, // Clear city if not found
        }));
    };
    

    const onChangePhoto = (photos: any) => {
        setNewPhotos(photos);
        setProperty({
            ...property,
            photos: [...property.photos, newPhotos],
            address,
        });
    };

    //Reset snackbar
    const handleCloseSnackbar = () => {
        setSnackValues({ ...snackValues, open: false });
    };

    //Cancel update
    const triggerUpdatingForm = () => {
        setIsUpdating(!isUpdating);
    };

    const cancelUpdatingForm = () => {
        setIsUpdating(false);
        setAnnounce(oldAnnounce);
        setProperty(oldProperty);
        setAddress(oldAddress);
        setNewPhotos([]);
        setEquipmentsSelected(oldEquipmentsSelected);
        setSnackValues({
            type: "info",
            open: true,
            message: t("snackbar.messages.modification-annule"),
        });
    };

    const showErrorsMessages = () => {
        let allErrorMessages = "";
        errors.forEach((error) => {

            if (error === "EMPTY CONTACT NAME") {
                allErrorMessages += "," + t(`label.error.${EAnnounceErrorMessages.EmptyContactName}`);
            } else if (error === "EMPTY CONTACT PHONE") {
                allErrorMessages += "," + t(`label.error.${EAnnounceErrorMessages.EmptyContactPhone}`);
            } else if (error === "EMPTY LOCATION DESCRIPTION") {
                allErrorMessages += "," + t(`label.error.${EAnnounceErrorMessages.EmptyLocationDescription}`);
            }
            
            // Specific to 'apts' and 'htls' validation
            if (SearchTypeName === "apts" || SearchTypeName === "htls") {
                if (error === "EMPTY NAME") {
                    allErrorMessages +=
                        "," + t(`label.error.${EPropertyErrorMessages.EmptyName}`);
                } else if (error === "EMPTY ROOM") {
                    allErrorMessages +=
                        "," + t(`label.error.${EPropertyErrorMessages.EmptyRoom}`);
                } else if (error === "EMPTY GUEST") {
                    allErrorMessages +=
                        "," + t(`label.error.${EPropertyErrorMessages.EmptyGuest}`);
                } else if (error === "EMPTY TYPE") {
                    allErrorMessages +=
                        "," + t(`label.error.${EPropertyErrorMessages.EmptyType}`);
                } else if (error === "EMPTY CITY") {
                    allErrorMessages +=
                        "," + t(`label.error.${EAddressErrorMessages.EmptyCity}`);
                } else if (error === "EMPTY COUNTRY") {
                    allErrorMessages +=
                        "," +
                        t(`label.error.${EAddressErrorMessages.EmptyCountry}`);
                } else if (error === "EMPTY STATE") {
                    allErrorMessages +=
                        "," + t(`label.error.${EAddressErrorMessages.EmptyState}`);
                } else if (error === "EMPTY ZIPCODE") {
                    allErrorMessages +=
                        "," +
                        t(`label.error.${EAddressErrorMessages.EmptyZipcode}`);
                } else if (error === "EMPTY DESCRIPTION") {
                    allErrorMessages +=
                        "," +
                        t(`label.error.${EAnnounceErrorMessages.EmptyDescription}`);
                } else if (error === "EMPTY PRICE") {
                    allErrorMessages +=
                        "," + t(`label.error.${EAnnounceErrorMessages.EmptyPrice}`);
                } 
            }
    
            // Specific to 'cars' validation
            if (SearchTypeName === "cars") {
                if (error === "EMPTY TYPE") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyType}`);
                } else if (error === "EMPTY NAME") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyName}`);
                } else if (error === "EMPTY PASSENGERS") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyPassengers}`);
                } else if (error === "EMPTY BAGS") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyBags}`);
                } else if (error === "EMPTY DOORS") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyDoors}`);
                } else if (error === "EMPTY BRAND") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyBrand}`);
                } else if (error === "EMPTY MODEL") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyModel}`);
                } else if (error === "EMPTY FUEL TYPE") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyFuelType}`);
                } else if (error === "EMPTY PLATE ID") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyPlateId}`);
                } else if (error === "EMPTY CHASSIS ID") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyChassisId}`);
                } else if (error === "EMPTY COLOR") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyColor}`);
                } else if (error === "EMPTY SEAT FABRIC") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptySeatFabric}`);
                } else if (error === "EMPTY INTERIOR COLOR") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyInteriorColor}`);
                } else if (error === "EMPTY GEARBOX") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyGearBox}`);
                } else if (error === "EMPTY ENGINE POWER") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyEnginePower}`);
                } else if (error === "EMPTY KILOMETERS") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyKilometers}`);
                } else if (error === "EMPTY INSURANCE PROVIDER") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyInsuranceProvider}`);
                } else if (error === "EMPTY INSURANCE EXPIRY DATE") {
                    allErrorMessages += "," + t(`label.error.${EVehicleErrorMessages.EmptyInsuranceExpiryDate}`);
                } 
            }
    
            // Specific to 'rstt' validation
            if (SearchTypeName === "rstt") {
                if (error === "EMPTY TYPE ANNONCE") {
                    allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptyTypeAnnonce}`);
                } else if (error === "EMPTY NAME") {
                    allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptyRsttName}`);
                } else if (error === "EMPTY NUMBER OF BEDROOMS") {
                    allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptyNumberOfBedrooms}`);
                } else if (error === "EMPTY NUMBER OF BATHROOMS") {
                    allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptyNumberOfBathrooms}`);
                } else if (error === "EMPTY SURFACE HABITABLE") {
                    allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptySurfaceHabitable}`);
                } else if (error === "EMPTY SUPERFICIE TERRAIN") {
                    allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptySuperficieTerrain}`);
                } else if (error === "EMPTY YEAR BUILT") {
                    allErrorMessages += "," + t(`label.error.${ERsttErrorMessages.EmptyYearBuilt}`);
                }
            }
    
        });
    
        setErrorMessages(allErrorMessages.substring(1, allErrorMessages.length));
    };


    const isPropertyValidate = (values: PropertyInputs, type: string): boolean => {
        // Clear previous errors
        errors = [];
    
        // Validation for apartments & hotels (apts, htls)
        if (SearchTypeName === "apts" || SearchTypeName === "htls") {
            if (type === "") {
                if (!errors.includes("EMPTY TYPE"))
                    errors = [...errors, "EMPTY TYPE"];
            } else if (values.name === "") {
                if (!errors.includes("EMPTY NAME"))
                    errors = [...errors, "EMPTY NAME"];
            } else if (values.maximumGuests === 0) {
                if (!errors.includes("EMPTY GUEST"))
                    errors = [...errors, "EMPTY GUEST"];
            } else if (values.rooms === "") {
                if (!errors.includes("EMPTY ROOM"))
                    errors = [...errors, "EMPTY ROOM"];
            }
        }
    
        // Validation for vehicles (cars)
        if (SearchTypeName === "cars") {
            if (!values.name || values.name.trim() === "") {
                errors.push("EMPTY NAME");
            }
            if (!values.vhcl_passengers || values.vhcl_passengers === 0) {
                errors.push("EMPTY PASSENGERS");
            }
            if (!values.vhcl_bags || values.vhcl_bags === 0) {
                errors.push("EMPTY BAGS");
            }
            if (!values.vhcl_doors || values.vhcl_doors === 0) {
                errors.push("EMPTY DOORS");
            }
            if (!values.vhcl_brand || values.vhcl_brand.trim() === "") {
                errors.push("EMPTY BRAND");
            }
            if (!values.vhcl_model || values.vhcl_model.trim() === "") {
                errors.push("EMPTY MODEL");
            }
            if (!values.vhcl_fuelType || values.vhcl_fuelType.trim() === "") {
                errors.push("EMPTY FUEL TYPE");
            }
            if (!values.vhcl_plaqueId || values.vhcl_plaqueId.trim() === "") {
                errors.push("EMPTY PLATE ID");
            }
            if (!values.vhcl_chassisId || values.vhcl_chassisId.trim() === "") {
                errors.push("EMPTY CHASSIS ID");
            }
            if (!values.vhcl_color || values.vhcl_color.trim() === "") {
                errors.push("EMPTY COLOR");
            }
            if (!values.vhcl_seatFabric || values.vhcl_seatFabric.trim() === "") {
                errors.push("EMPTY SEAT FABRIC");
            }
            if (!values.vhcl_interiorColor || values.vhcl_interiorColor.trim() === "") {
                errors.push("EMPTY INTERIOR COLOR");
            }
            if (!values.vhcl_gearBox || values.vhcl_gearBox.trim() === "") {
                errors.push("EMPTY GEARBOX");
            }
            if (!values.vhcl_enginePower || values.vhcl_enginePower === 0) {
                errors.push("EMPTY ENGINE POWER");
            }
            if (!values.vhcl_kilometers || values.vhcl_kilometers === 0) {
                errors.push("EMPTY KILOMETERS");
            }
            if (!values.vhcl_insuranceProvider || values.vhcl_insuranceProvider.trim() === "") {
                errors.push("EMPTY INSURANCE PROVIDER");
            }
            if (!values.vhcl_insuranceExpiryDate) {
                errors.push("EMPTY INSURANCE EXPIRY DATE");
            }
        }
    
        // Validation for real estate (rstt)
        if (SearchTypeName === "rstt") {
            if (!values.rstt_typeAnnonce || values.rstt_typeAnnonce.trim() === "") {
                errors.push("EMPTY TYPE ANNONCE");
            }
            if (!values.rstt_numberOfBedrooms || values.rstt_numberOfBedrooms === 0) {
                errors.push("EMPTY NUMBER OF BEDROOMS");
            }
            if (!values.rstt_numberOfBathrooms || values.rstt_numberOfBathrooms === 0) {
                errors.push("EMPTY NUMBER OF BATHROOMS");
            }
            if (!values.rstt_surfaceHabitable || values.rstt_surfaceHabitable === 0) {
                errors.push("EMPTY SURFACE HABITABLE");
            }
            if (!values.rstt_superficieTerrain || values.rstt_superficieTerrain === 0) {
                errors.push("EMPTY SUPERFICIE TERRAIN");
            }
            if (!values.rstt_yearBuilt || values.rstt_yearBuilt === 0) {
                errors.push("EMPTY YEAR BUILT");
            }
        }
    
        return !Boolean(errors.length);
    };

    const isAddressValidate = (values: IAddress): boolean => {
        errors = [];
        if (values.city?.name === "") {
            if (!errors.includes("EMPTY CITY"))
                errors = [...errors, "EMPTY CITY"];
        }

        if (SearchTypeName === "apts" || SearchTypeName === "htls") {
            if (values.quartier === "") {
                if (!errors.includes("EMPTY QUARTIER"))
                    errors = [...errors, "EMPTY QUARTIER"];
            }
        }    

        return !Boolean(errors.length);
    };

    const isAnnounceValidate = (values: AnnounceInputs, searchTypeName?: string): boolean => {
            errors = [];
        
            // Check for empty description
            if (values.description === "") {
                if (!errors.includes("EMPTY DESCRIPTION")) {
                    errors = [...errors, "EMPTY DESCRIPTION"];
                }
            }
        
            // Check for empty price only if SearchTypeName is not "trs"
            if (searchTypeName !== "trs" && values.price === 0) {
                if (!errors.includes("EMPTY PRICE")) {
                    errors = [...errors, "EMPTY PRICE"];
                }
            }
        
            // Return true if there are no errors, false otherwise
            return !Boolean(errors.length);
        };

    const isPhotosValidate = (values: PropertyInputs): boolean => {
        errors = [];
        if (newPhotos?.length < 5 && values.photos?.length < 5) {
            if (!errors.includes("INSUFFICIENT PICTURES")) {
                errors.push("INSUFFICIENT PICTURES");
            }
        }
        return !Boolean(errors.length);
    };

    const isAnnounceStepSix = (values: AnnounceInputs, property: PropertyInputs): boolean => {
        errors = [];

        if (SearchTypeName === "rstt" || SearchTypeName === "cars" || SearchTypeName === "trs") {
            //console.log("Bypassing Step Six validation for 'rstt'.");
            return true; // No validation for 'rstt'
        }

        if (property.address.country?.name === "Cameroon" && values.favoritePaymentMethod === "") {
            errors.push("EMPTY PREFERRED METHOD");
        } else if (property.address.country?.name === "Cameroon" && values.favoritePaymentMethod !== "") {
            if (values.favoritePaymentMethod === EPaymentMethod.Orange && values.account_orange === "") {
                errors.push("EMPTY ORANGE ACCOUNT");
            }
            if (values.favoritePaymentMethod === EPaymentMethod.MTN && values.account_mtn === "") {
                errors.push("EMPTY MTN ACCOUNT");
            }
        }
        
        if (SearchTypeName === "apts" || SearchTypeName === "htls") {
            if (values.penaltyDayFees === 0 && values.remboursable === "remboursable") {
                errors.push("NULL PENALTY");
            }
        }    
    
        
    
        return !Boolean(errors.length);
    };
    
    const isAnnounceStepEight = (values: AnnounceInputs): boolean => {
        errors = [];

        if (SearchTypeName === "rstt" || SearchTypeName === "cars") {
            //console.log("Bypassing Step Six validation for 'rstt'.");
            return true; // No validation for 'rstt'
        }
    
        if (values.contactName === "") {
            errors.push("EMPTY CONTACT NAME");
        }
        if (values.contactPhone === "") {
            errors.push("EMPTY CONTACT PHONE");
        }
        if (values.howToAccessDesc === "") {
            errors.push("EMPTY LOCATION DESCRIPTION");
        }
    
        return errors.length === 0;
    };


    //On delete hotos
    const onDeletePhoto = (
        idProperty: string,
        idPhoto: string,
        photoName?: string
    ) => {
        if (photoName) {
            propertyService
                .deletePropertyPhotoByName(idProperty, photoName)
                .then((response) => {
                    if (response.success) {
                        refreshPhotos();
                    }
                });
        } else {
            propertyService
                .deletePropertyPhotoById(idProperty, idPhoto)
                .then((response) => {
                    if (response.success) {
                        refreshPhotos();
                    }
                });
        }
    };

    const paymentTypeHandler = (values: any) => {
        setSelectedPaymentMethod(values);
        const value = values.map((value: any) => value.value);

        setPayment(value);
    };

    let tabPaypal: any = [];
    let tabBancare: any = [];
    let tabMobile: any = [];
    for (let i in payment) {
        if (payment[i] === EPaymentMethod.Paypal) {
            if (user.payments.paypal.length !== 0) {
                user.payments.paypal.forEach((paypl) => {
                    tabPaypal.push({
                        payement: "Paypal",
                        label:
                            paypl.recepient_email ||
                            paypl.recepient_paypal_id ||
                            paypl.recepient_phone,
                        value: paypl._id || "",
                    });
                });
            }
        } else if (payment[i] === EPaymentMethod.Orange) {
            if (user.payments.mobileMoney.length !== 0) {
                user.payments.mobileMoney.forEach((mm) => {
                    tabMobile.push({
                        payement: "Orange",
                        label: mm.mobile_number,
                        value: mm._id || " ",
                    });
                });
            }
        } else if (payment[i] === EPaymentMethod.MTN) {
            if (user.payments.mobileMoney.length !== 0) {
                user.payments.mobileMoney.forEach((mm) => {
                    tabMobile.push({
                        payement: "MTN",
                        label: mm.mobile_number,
                        value: mm._id || " ",
                    });
                });
            }
        } else if (payment[i] === EPaymentMethod.Nexttel) {
            if (user.payments.mobileMoney.length !== 0) {
                user.payments.mobileMoney.forEach((mm) => {
                    tabMobile.push({
                        payement: "Nexttel",
                        label: mm.mobile_number,
                        value: mm._id || " ",
                    });
                });
            }
        }
    }
    let tabResult = tabPaypal.concat(tabBancare, tabMobile);

    const tabResultNow: string[] = [];

    if (selectedPaymentMethod.includes("Paypal"))
        tabResultNow.push(announce.account_paypal);
    else if (selectedPaymentMethod.includes("Orange Money"))
        tabResultNow.push(announce.account_orange);
    let tabMethod: any = [];
    const onChangePaymentMethod = (values: any): void => {
        setSelectedPaymentMethod(values);
        setAnnounce((prevAnnounce) => {
            return prevAnnounce;
        });
    };
    
    
    
    

    //refresh photos
    const refreshPhotos = () => {
        setLoading(true);
        propertyService
            .refreshPropertyPhotos(property._id || "")
            .then((response) => {
                if (response.success) {
                    setPreviewPhotos(
                        response.photos.map((photo: any) => {
                            if (photo.fileURL) {
                                return {
                                    id: photo._id,
                                    url: photo.fileURL,
                                    filename: photo.filename,
                                };
                            }
                            return {
                                id: photo._id,
                                url: "",
                            };
                        })
                    );

                    setProperty({
                        ...property,
                        photos: response.photos,
                    });
                }

                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    };

    //refresh all data property
    const refreshAllPropertyData = () => {
        propertyService
            .getAnnounceByIdAdm(params.id)
            .then((resAnnounce) => {
                if (resAnnounce.success) {
                    setSnackValues({
                        ...snackValues,
                        open: true,
                        message: t(
                            "snackbar.messages.annonce-modifie-avec-succes"
                        ),
                    });
                    setAnnounce(resAnnounce.data);

                    setOldAnnounce(resAnnounce.data);

                    setProperty({
                        ...resAnnounce.data.property,
                        type: resAnnounce.data.property.type,
                    });
                    setOldProperty({
                        ...resAnnounce.data.property,
                        type: resAnnounce.data.property.type,
                    });

                    setPreviewPhotos(
                        resAnnounce.data.property.photos.map((photo: any) => {
                            if (photo.fileURL) {
                                return {
                                    id: photo._id,
                                    url: photo.fileURL,
                                    filename: photo.filename,
                                };
                            }
                            return {
                                id: photo._id,
                                url: "",
                            };
                        })
                    );

                    setAddress(resAnnounce.data.property.address);
                    setOldAddress(resAnnounce.data.property.address);
                    setEquipmentsSelected(
                        resAnnounce.data.property?.equipments.filter((eq: IEquipment) =>
                            equipmentsList.some((listEq) => listEq._id === eq._id)
                        )
                    );
                    
                    setOldEquipmentsSelected(
                        resAnnounce.data.property.equipments
                    );

                    setErrorMessages("");
                    errors = [];
                    setIsUpdating(false);
                    setLoading(false);
                    setTimeout(() => {
                        history.push("/announces");
                    }, 1000);
                }
            })
            .catch((errAnnounce) => {
                console.log("errAnnounce", errAnnounce);
                setLoading(false);
            });
    };

    let tab: any = [];
    property.photos.forEach((pho: any) => {
        if (pho.filename !== undefined) {
            tab.push(pho);
        }
    });
    
    const handleSubmit = (e: any) => {
        e.preventDefault();
    
        /*console.log("Starting handleSubmit process...");
        console.log("Property:", property);
        console.log("Address:", address);
        console.log("Announce:", announce);
        console.log("New Photos:", newPhotos);*/
    
        let validationResults = {
            propertyValidation: isPropertyValidate(property, property.type),
            addressValidation: isAddressValidate(address),
            announceValidation: isAnnounceValidate(announce),
            photosValidation: isPhotosValidate(property),
            stepSixValidation: isAnnounceStepSix(announce, property),
            stepEightValidation: isAnnounceStepEight(announce),
        };
    
        //console.log("Validation results:", validationResults);
    
        if (
            validationResults.propertyValidation &&
            validationResults.addressValidation &&
            validationResults.announceValidation &&
            validationResults.photosValidation &&
            validationResults.stepSixValidation &&
            validationResults.stepEightValidation
        ) {
            //console.log("All validations passed. Proceeding to submit...");
    
            setLoading(true);
            propertyService
                .updatePropertyById({ ...property, photos: tab })
                .then((response) => {
                    if (response.success === true) {
                        //console.log("Property update successful. Proceeding to save announce...");
    
                        propertyService
                            .saveAnnounce(announce, property._id || params.id)
                            .then((response) => {
                                if (response.success) {
                                    console.log("Announce saved successfully.");
                                }
                            })
                            .catch((error) => {
                                console.error("Error saving announce:", error);
                                setLoading(false);
                            });
    
                        if (newPhotos.length) {
                            //console.log("Uploading new photos...");
                            newPhotos.forEach((photo: any) => {
                                let formData = new FormData();
                                formData.append(`photo`, photo.file);
                                if (property._id) {
                                    propertyService
                                        .savePropertyPhotosById(
                                            property._id,
                                            formData
                                        )
                                        .then((response) => {
                                            if (response.success) {
                                                //console.log("Photo upload successful:", photo.filename);
                                                refreshAllPropertyData();
                                            }
                                        })
                                        .catch((error) => {
                                            console.error("Error uploading photos:", error);
                                            setLoading(false);
                                        });
                                }
                            });
                        } else {
                            //console.log("No new photos to upload. Refreshing data...");
                            refreshAllPropertyData();
                        }
                    }
                })
                .catch((error) => {
                    console.error("Error updating property:", error);
                    setLoading(false);
                    showErrorsMessages();
                });
        } else {
            console.warn("Validation failed. Showing error messages...");
            console.log("Validation errors:", errors);
            showErrorsMessages();
        }
    };
    

    const handleOnChangeSelect = (key: string, v: string) => {
        setAnnounce({ ...announce, [key]: v });
    };

    const onChangeSpecialPriceAnnounce = (event: any): void => {
        switch (event.target.name) {
            case "priceWeeklyDaily": {
                setPriceWeeklyDaily(event.target.value);
                setAnnounce({
                    ...announce,
                    priceWeekly: event.target.value * 7,
                });
                break;
            }
            case "priceBiWeeklyDaily": {
                setPriceBiWeeklyDaily(event.target.value);
                setAnnounce({
                    ...announce,
                    priceBiWeekly: event.target.value * 14,
                });
                break;
            }
            case "priceMonthlyDaily": {
                setPriceMonthlyDaily(event.target.value);
                setAnnounce({
                    ...announce,
                    priceMonthly: event.target.value * 30,
                });
                break;
            }
            case "priceWeekly": {
                setAnnounce({ ...announce, priceWeekly: event.target.value });
                setPriceWeeklyDaily(
                    Number(
                        (event.target.value / 7).toFixed(
                            devise?.toUpperCase() === "XAF" ? 0 : 2
                        )
                    )
                );
                break;
            }
            case "priceBiWeekly": {
                setAnnounce({ ...announce, priceBiWeekly: event.target.value });
                setPriceBiWeeklyDaily(
                    Number(
                        (event.target.value / 14).toFixed(
                            devise?.toUpperCase() === "XAF" ? 0 : 2
                        )
                    )
                );
                break;
            }
            case "priceMonthly": {
                setAnnounce({ ...announce, priceMonthly: event.target.value });
                setPriceMonthlyDaily(
                    Number(
                        (event.target.value / 30).toFixed(
                            devise?.toUpperCase() === "XAF" ? 0 : 2
                        )
                    )
                );
                break;
            }
        }
    };
    let tabPays: any = [];
    paysList &&
        paysList.map((pays: any) => {
            if (pays.name === address.country?.name) {
                pays.villes.map((vil: any) => {
                    tabPays.push(vil);
                });
            }
        });
    const setRankVisible = (e: any) => {
        setRank(e);
    };
    const setAnimals = (e: any) => {
        setRankAnimals(e);
    };
    const setChilds = (e: any) => {
        setRankChilds(e);
    };

    const onChangeVille = (value: any): void => {
        setVilleSelected(value);
        let tab: any = [];
        value.map((value: any) => tab.push(value.name));
        setVille(tab);
    };
    
    
    let tabN: any = [];
    for (let i = 0; i <= 30; i++) {
        tabN.push({ name: i });
    }

    const carBrands = [
        "Toyota", "Honda", "Renault", "Peugeot", "Nissan", "Volkswagen", "Ford",
        "Mercedes-Benz", "BMW", "Hyundai", "Kia", "Chevrolet", "Mitsubishi",
        "Suzuki", "Isuzu", "Land Rover", "Jeep", "Dacia", "Fiat", "Chery",
        "Citroën", "Seat", "Tacoma", "Mazda", "Subaru", "Lexus", "Opel", "GMC",
        "Changan", "Tata Motors", "Mahindra", "SsangYong", "Geely", "BYD",
        "Great Wall Motors", "Dongfeng", "FAW", "Proton", "Daewoo", "Alfa Romeo"
    ].sort();    

    return (
        <>
            { (property.type?.searchType?.name === "apts" || property.type?.searchType?.name === "htls") && (     
                <>    
                    <Typography
                        variant="h5"
                        gutterBottom
                        className={classes.propertiesTitle}
                    >
                        {t("label.modification-d-annonce")}
                    </Typography>
                    <div className={classes.editContainer}>
                        {loadingPage ? (
                            <CircularProgress size={32} style={{ color: "#890608" }} />
                        ) : (
                            <form
                                className={classes.root}
                                noValidate
                                autoComplete="off"
                                onSubmit={handleSubmit}
                            >
                                <Grid
                                    container
                                    spacing={2}
                                    style={{ justifyContent: "space-around" }}
                                >
                                    <Grid
                                        item
                                        lg={8}
                                        sm={12}
                                        className={classes.propertyInfosContainer}
                                    >
                                        <Grid container spacing={2}>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyName"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.nomDeLaPropriete"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyName"
                                                    fullWidth
                                                    name="name"
                                                    value={property.name}
                                                    onChange={onChangeHandler}
                                                    inputProps={{
                                                        readOnly: true, // Set to always read-only
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyMaximumGuests"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.nombreMaximumDInvites"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyMaximumGuests"
                                                    fullWidth
                                                    name="maximumGuests"
                                                    value={property.maximumGuests}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyRooms"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.nombreDeChambres"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyRooms"
                                                    fullWidth
                                                    name="rooms"
                                                    value={property.rooms}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyRooms"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.nombreDeBathrooms"
                                                    )}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyRooms"
                                                    fullWidth
                                                    name="bathrooms"
                                                    value={property.bathrooms}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyRooms"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.nombreDeLits")}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyRooms"
                                                    fullWidth
                                                    name="lit"
                                                    value={property.lit}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyEquipments"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.equipements")}{" "}
                                                    :
                                                </label>
                                            </Grid>                                            
                                            <Grid item lg={8} sm={9} xs={12} className={classes.inpuText}>
                                                <Grid container>
                                                    {tab_eq.map((cat: any) => {
                                                        return (
                                                            <>
                                                                <Grid item xs={12} className={classes.category}>
                                                                    <span>{cat.categorie}</span>
                                                                </Grid>
                                                                {cat.equipement.map((eq: IEquipment) => {
                                                                    const equipmentName = i18n.language === "fr" ? eq.name?.fr : eq.name?.en;

                                                                    // Check if the current equipment is selected by checking in `equipmentsSelected`
                                                                    const isChecked = equipmentsSelected.some((selectedEq) => selectedEq._id === eq._id);

                                                                    return (
                                                                        <Grid
                                                                            item
                                                                            lg={4}
                                                                            md={4}
                                                                            sm={4}
                                                                            xs={6}
                                                                            key={eq._id}
                                                                        >
                                                                            <CheckableTreeItem
                                                                                onChecked={isUpdating ? () => handleCheck(eq) : undefined}
                                                                                checkable
                                                                                node={{
                                                                                    label: (
                                                                                        <span style={{ color: "#999", fontSize: "smaller" }}>
                                                                                            {equipmentName}
                                                                                        </span>
                                                                                    ),
                                                                                    // Set the checkbox checked state based on whether it's selected
                                                                                    checked: isChecked,
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    );
                                                                })}

                                                            </>
                                                        );
                                                    })}
                                                </Grid>
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label htmlFor="propertyCountry" className={classes.label}>
                                                    {t("propriete.labels.pays")}* :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <Select
                                                    id="propertyCountry"
                                                    name="country"
                                                    fullWidth
                                                    value={i18n.language === "fr" ? address.country?.nomFR || "" : address.country?.nomEN || ""}
                                                    onChange={onChangePropertyPaysHandler}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                >
                                                    {paysList.map((country: IPays) => (
                                                        <MenuItem value={i18n.language === "fr" ? country.nomFR : country.nomEN} key={country._id}>
                                                            {i18n.language === "fr" ? country.nomFR : country.nomEN}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label htmlFor="propertyCity" className={classes.label}>
                                                    {t("propriete.labels.nomDeLaVille")}* :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <Select
                                                    id="propertyCity"
                                                    name="city"
                                                    fullWidth
                                                    value={i18n.language === "fr" ? address.city?.nomFR || "" : address.city?.nomEN || ""}
                                                    onChange={onChangePropertyVilleHandler}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                >
                                                    {filteredCities.map((city: IVille) => (
                                                    <MenuItem value={i18n.language === "fr" ? city.nomFR : city.nomEN} key={city._id}>
                                                        {i18n.language === "fr" ? city.nomFR : city.nomEN}
                                                    </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyZipCode"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.codePostal")} :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyZipCode"
                                                    fullWidth
                                                    name="zipcode"
                                                    value={address.zipcode}
                                                    onChange={onChangeAddress}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="properState"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.etatOuProvince"
                                                    )}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="properState"
                                                    fullWidth
                                                    name="state"
                                                    value={address.state}
                                                    onChange={onChangeAddress}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="properState"
                                                    className={classes.label}
                                                >
                                                    {t("listTable.labels.quartier")}* :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="properState"
                                                    fullWidth
                                                    name="quartier"
                                                    value={address.quartier}
                                                    onChange={onChangeAddress}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    Description
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <DescriptionRichText
                                                    handleChange={onChangeAnnonce}
                                                    isCanceled={!isUpdating}
                                                    description={announce.description}
                                                    readOnly={!isUpdating}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t("annonce.labels.tarif-de-base")}{" "}
                                                    ({announce.devise})* :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePrice"
                                                    fullWidth
                                                    name="price"
                                                    value={announce.price}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                        "annonce.labels.tarif-hebdomadaire"
                                                    )}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceWeekly"
                                                    fullWidth
                                                    name="priceWeekly"
                                                    value={announce.priceWeekly}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                        "annonce.labels.tarif-hebdomadaire-par-jour"
                                                    )}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceWeeklyDaily"
                                                    fullWidth
                                                    name="priceWeeklyDaily"
                                                    value={priceWeeklyDaily}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                        "annonce.labels.tarif-de-quinzaine"
                                                    )}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceBiWeekly"
                                                    fullWidth
                                                    name="priceBiWeekly"
                                                    value={announce.priceBiWeekly}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                        "annonce.labels.tarif-de-quinzaine-par-jour"
                                                    )}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceBiWeeklyDaily"
                                                    fullWidth
                                                    name="priceBiWeeklyDaily"
                                                    value={priceBiWeeklyDaily}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t("annonce.labels.tarif-mensuel")}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceMonthly"
                                                    fullWidth
                                                    name="priceMonthly"
                                                    value={announce.priceMonthly}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                        "annonce.labels.tarif-mensuel-par-jour"
                                                    )}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceMonthlyDaily"
                                                    fullWidth
                                                    name="priceMonthlyDaily"
                                                    value={priceMonthlyDaily}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t("label.frais-de-nettoyage")} (
                                                    {announce.devise})* :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePrice"
                                                    fullWidth
                                                    name="cleaningFees"
                                                    value={announce.cleaningFees}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    className={classes.label}
                                                    htmlFor="cancellationPolicyText"
                                                >
                                                    {t(
                                                        "annonce.labels.politiqueDAnnulation"
                                                    )}
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <PropertyTextFieldMulitline
                                                    id="cancellationPolicyText"
                                                    label={""}
                                                    name="cancellationPolicy"
                                                    value={announce.cancellationPolicy}
                                                    handleChange={onChangeAnnonce}
                                                    minRows={2}
                                                    upDatingProps={!isUpdating}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="account_paypal"
                                                    className={classes.label}
                                                >
                                                    {`${t("label.compte-paypal")} : `}
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="account_paypal"
                                                    fullWidth
                                                    name="account_paypal"
                                                    value={announce.account_paypal}
                                                    InputProps={{
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>
                                            {address.country?.name === "Cameroon" && (
                                                <>
                                                    <Grid item lg={4} sm={3} xs={12}>
                                                        <label
                                                            htmlFor="account_orange"
                                                            className={classes.label}
                                                        >
                                                            {`${t(
                                                                "label.compte-orange"
                                                            )} : `}
                                                        </label>
                                                    </Grid>
                                                    <Grid item lg={8} sm={9} xs={12}>
                                                        <TextField
                                                            id="account_orange"
                                                            fullWidth
                                                            name="account_orange"
                                                            value={
                                                                announce.account_orange
                                                            }
                                                            onChange={onChangeAnnonce}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <div
                                                                        style={{
                                                                            marginRight: 10,
                                                                        }}
                                                                    >
                                                                        {codeNum}
                                                                    </div>
                                                                ),
                                                                inputProps: {
                                                                    readOnly:
                                                                        !isUpdating,
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={4} sm={3} xs={12}>
                                                        <label
                                                            htmlFor="account_mtn"
                                                            className={classes.label}
                                                        >
                                                            {`${t(
                                                                "label.compte-mtn"
                                                            )} : `}
                                                        </label>
                                                    </Grid>
                                                    <Grid item lg={8} sm={9} xs={12}>
                                                        <TextField
                                                            id="account_mtn"
                                                            fullWidth
                                                            name="account_mtn"
                                                            value={announce.account_mtn}
                                                            onChange={onChangeAnnonce}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <div
                                                                        style={{
                                                                            marginRight: 10,
                                                                        }}
                                                                    >
                                                                        {codeNum}
                                                                    </div>
                                                                ),
                                                                inputProps: {
                                                                    readOnly:
                                                                        !isUpdating,
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={4} sm={3} xs={12}>
                                                        <label
                                                            htmlFor="account_express_union"
                                                            className={classes.label}
                                                        >
                                                            {`${t(
                                                                "label.compte-express-union"
                                                            )} : `}
                                                        </label>
                                                    </Grid>
                                                    <Grid item lg={8} sm={9} xs={12}>
                                                        <TextField
                                                            id="account_express_union"
                                                            fullWidth
                                                            name="account_express_union"
                                                            value={
                                                                announce.account_express_union
                                                            }
                                                            onChange={onChangeAnnonce}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <div
                                                                        style={{
                                                                            marginRight: 10,
                                                                        }}
                                                                    >
                                                                        {codeNum}
                                                                    </div>
                                                                ),
                                                                inputProps: {
                                                                    readOnly:
                                                                        !isUpdating,
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={4} sm={3} xs={12}>
                                                        <label
                                                            htmlFor="favoritePaymentMethod"
                                                            className={classes.label}
                                                        >
                                                            {t(
                                                                "label.favoritePaymentMethod"
                                                            )}{" "}
                                                            :
                                                        </label>
                                                    </Grid>
                                                    <Grid item lg={8} sm={9} xs={12}>
                                                        <Select
                                                            id="favoritePaymentMethod"
                                                            name="favoritePaymentMethod"
                                                            fullWidth
                                                            value={
                                                                announce.favoritePaymentMethod
                                                            }
                                                            onChange={onChangeAnnonce}
                                                            autoFocus
                                                            inputProps={{
                                                                readOnly: !isUpdating,
                                                            }}
                                                        >
                                                            {paymentMethodMobileList.map(
                                                                (method) => (
                                                                    <MenuItem
                                                                        value={
                                                                            method.value
                                                                        }
                                                                        key={
                                                                            method.label +
                                                                            method.value
                                                                        }
                                                                    >
                                                                        {method.label}
                                                                    </MenuItem>
                                                                )
                                                            )}
                                                        </Select>
                                                    </Grid>
                                                </>
                                            )}

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <span>Checkin:</span>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TimePicker
                                                    value={checkin}
                                                    onChange={handleValueChange}
                                                    showSecond={false}
                                                    allowEmpty
                                                    disabled={!isUpdating}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <span>Checkout:</span>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TimePicker
                                                    value={checkout}
                                                    onChange={handleValueChangeOut}
                                                    showSecond={false}
                                                    allowEmpty
                                                    disabled={!isUpdating}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    className={classes.label}
                                                    htmlFor="rules"
                                                >
                                                    {t("label.reglements-interieurs")} :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <PropertyTextFieldMulitline
                                                    id="rules"
                                                    label={""}
                                                    name="rules"
                                                    value={announce.rules}
                                                    handleChange={onChangeAnnonce}
                                                    minRows={2}
                                                    upDatingProps={!isUpdating}
                                                />
                                                <RadioGroup
                                                    row
                                                    aria-label="position"
                                                    value={valueGroup}
                                                    onChange={handleChangeGroup}
                                                >
                                                    <FormControlLabel
                                                        value="remboursable"
                                                        control={
                                                            <Radio color="primary" />
                                                        }
                                                        label={t(
                                                            "annonce.remborse-titre"
                                                        )}
                                                        disabled={!isUpdating}
                                                        style={{ fontSize: "inherit" }}
                                                        labelPlacement="end"
                                                    />
                                                    <div>
                                                        <p className={classes.annuler}>
                                                            <span
                                                                style={{
                                                                    whiteSpace:
                                                                        "nowrap",
                                                                }}
                                                            >
                                                                {" "}
                                                                1-{" "}
                                                                {t(
                                                                    "detail-annonce.refundItem11"
                                                                )}{" "}
                                                            </span>
                                                            <SelectEndornmentNationPolitique
                                                                id="country"
                                                                name="freeRefundDay"
                                                                values={tabN}
                                                                selectedValue={
                                                                    announce.freeRefundDay
                                                                }
                                                                remboursable={
                                                                    valueGroup
                                                                }
                                                                handleOnChange={
                                                                    handleOnChangeSelect
                                                                }
                                                                isUpdating={!isUpdating}
                                                            />
                                                            <span
                                                                style={{
                                                                    marginLeft: 10,
                                                                }}
                                                            >
                                                                {" "}
                                                                {t(
                                                                    "detail-annonce.refundItem12"
                                                                )}
                                                                .
                                                            </span>
                                                        </p>{" "}
                                                        <br />
                                                        <p className={classes.annuler}>
                                                            <span
                                                                style={{
                                                                    whiteSpace:
                                                                        "nowrap",
                                                                }}
                                                            >
                                                                2-{" "}
                                                                {t(
                                                                    "detail-annonce.refundItem21"
                                                                )}
                                                            </span>
                                                            {announce.freeRefundDay}
                                                            <span
                                                                style={{
                                                                    marginLeft: 10,
                                                                }}
                                                            >
                                                                {t(
                                                                    "detail-annonce.refundItem22"
                                                                )}
                                                            </span>
                                                            <SelectEndornmentNationPolitique
                                                                id="country"
                                                                name="penaltyDayFees"
                                                                values={tabN}
                                                                selectedValue={
                                                                    announce.penaltyDayFees
                                                                }
                                                                remboursable={
                                                                    valueGroup
                                                                }
                                                                handleOnChange={
                                                                    handleOnChangeSelect
                                                                }
                                                                isUpdating={!isUpdating}
                                                            />
                                                            <span
                                                                style={{
                                                                    marginLeft: 10,
                                                                }}
                                                            >
                                                                {t(
                                                                    "detail-annonce.refundItem23"
                                                                )}{" "}
                                                                .{" "}
                                                            </span>
                                                        </p>
                                                        <br />
                                                        <p className={classes.annuler}>
                                                            <span
                                                                style={{
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                3-{" "}
                                                                {t(
                                                                    "detail-annonce.refundItem31"
                                                                )}
                                                            </span>
                                                            <SelectEndornmentNationPolitique
                                                                id="country"
                                                                name="penaltyDayFeesAfterBookingStarted"
                                                                values={tabN}
                                                                remboursable={
                                                                    valueGroup
                                                                }
                                                                selectedValue={
                                                                    announce.penaltyDayFeesAfterBookingStarted
                                                                }
                                                                handleOnChange={
                                                                    handleOnChangeSelect
                                                                }
                                                                isUpdating={!isUpdating}
                                                            />
                                                            <span
                                                                style={{
                                                                    marginLeft: 10,
                                                                }}
                                                            ></span>
                                                            {t(
                                                                "detail-annonce.refundItem32"
                                                            )}
                                                        </p>
                                                    </div>
                                                    <FormControlLabel
                                                        value="noremboursable"
                                                        control={
                                                            <Radio color="primary" />
                                                        }
                                                        label={t(
                                                            "annonce.option-not-remb"
                                                        )}
                                                        style={{ fontSize: "inherit" }}
                                                        disabled={!isUpdating}
                                                        labelPlacement="end"
                                                    />
                                                    <div>
                                                        <p className={classes.annuler}>
                                                            <span
                                                                style={{
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                1-{" "}
                                                                {t("annonce.not-remb1")}
                                                                <SelectEndornmentNationPolitiqueNoremb
                                                                    id="country"
                                                                    name="notRemboursable1"
                                                                    values={tabN}
                                                                    selectedValue={
                                                                        announce?.notRemboursable1
                                                                    }
                                                                    remboursable={
                                                                        valueGroup
                                                                    }
                                                                    handleOnChange={
                                                                        handleOnChangeSelect
                                                                    }
                                                                    isUpdating={
                                                                        !isUpdating
                                                                    }
                                                                />{" "}
                                                                {t("annonce.not-remb2")}
                                                            </span>
                                                        </p>
                                                        <p className={classes.annuler}>
                                                            <span
                                                                style={{
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                2-{" "}
                                                                {t("annonce.not-remb3")}
                                                                {
                                                                    announce?.notRemboursable1
                                                                }
                                                                {t("annonce.not-remb4")}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </RadioGroup>
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}></Grid>
                                            <Grid
                                                container
                                                item
                                                lg={8}
                                                sm={9}
                                                xs={12}
                                                alignItems="flex-start"
                                                direction="column"
                                            >
                                                <Grid
                                                    item
                                                    style={{
                                                        marginTop: 20,
                                                        marginBottom: 5,
                                                        fontSize: 20,
                                                    }}
                                                >
                                                    {" "}
                                                    {t("detail-annonce.animals")} ?{" "}
                                                </Grid>
                                                <Grid item>
                                                    <RadioGroup
                                                        row
                                                        aria-label="position"
                                                        name="position"
                                                        defaultValue="non"
                                                    >
                                                        <FormControlLabel
                                                            value="oui"
                                                            control={
                                                                <Radio color="primary" />
                                                            }
                                                            label={t("label.oui")}
                                                            labelPlacement="end"
                                                            checked={animals}
                                                            onChange={() =>
                                                                setAnimals(true)
                                                            }
                                                            disabled={!isUpdating}
                                                        />
                                                        <FormControlLabel
                                                            value="non"
                                                            control={
                                                                <Radio color="primary" />
                                                            }
                                                            label={t("label.non")}
                                                            labelPlacement="end"
                                                            checked={!animals}
                                                            onChange={() =>
                                                                setAnimals(false)
                                                            }
                                                            disabled={!isUpdating}
                                                        />
                                                    </RadioGroup>
                                                </Grid>
                                                <Grid
                                                    item
                                                    style={{
                                                        marginTop: 20,
                                                        marginBottom: 5,
                                                        fontSize: 20,
                                                    }}
                                                >
                                                    {" "}
                                                    {t(
                                                        "detail-annonce.children"
                                                    )} ?{" "}
                                                </Grid>
                                                <Grid item>
                                                    <RadioGroup
                                                        row
                                                        aria-label="position"
                                                        name="position"
                                                        defaultValue="non"
                                                    >
                                                        <FormControlLabel
                                                            value="oui"
                                                            control={
                                                                <Radio color="primary" />
                                                            }
                                                            label={t("label.oui")}
                                                            labelPlacement="end"
                                                            checked={childs}
                                                            onChange={() =>
                                                                setChilds(true)
                                                            }
                                                            disabled={!isUpdating}
                                                        />
                                                        <FormControlLabel
                                                            value="non"
                                                            control={
                                                                <Radio color="primary" />
                                                            }
                                                            label={t("label.non")}
                                                            labelPlacement="end"
                                                            checked={!childs}
                                                            onChange={() =>
                                                                setChilds(false)
                                                            }
                                                            disabled={!isUpdating}
                                                        />
                                                    </RadioGroup>
                                                </Grid>
                                                <Grid
                                                    item
                                                    style={{
                                                        marginTop: 20,
                                                        marginBottom: 5,
                                                        fontSize: 20,
                                                    }}
                                                >
                                                    {" "}
                                                    {t("detail-annonce.fetes")} ?{" "}
                                                </Grid>
                                                <Grid item>
                                                    <RadioGroup
                                                        row
                                                        aria-label="position"
                                                        name="position"
                                                        defaultValue="non"
                                                    >
                                                        <FormControlLabel
                                                            value="oui"
                                                            control={
                                                                <Radio color="primary" />
                                                            }
                                                            label={t("label.oui")}
                                                            labelPlacement="end"
                                                            checked={rank}
                                                            onChange={() =>
                                                                setRankVisible(true)
                                                            }
                                                            disabled={!isUpdating}
                                                        />
                                                        <FormControlLabel
                                                            value="non"
                                                            control={
                                                                <Radio color="primary" />
                                                            }
                                                            label={t("label.non")}
                                                            labelPlacement="end"
                                                            checked={!rank}
                                                            onChange={() =>
                                                                setRankVisible(false)
                                                            }
                                                            disabled={!isUpdating}
                                                        />
                                                    </RadioGroup>
                                                </Grid>
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t("annonce.labels.nom-du-contact")}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="contactName"
                                                    fullWidth
                                                    name="contactName"
                                                    value={announce.contactName}
                                                    InputProps={{
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="contactPhone"
                                                    className={classes.label}
                                                >
                                                    {`${t(
                                                        "annonce.labels.numero-du-contact"
                                                    )} : `}
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="contactPhone"
                                                    fullWidth
                                                    name="contactPhone"
                                                    value={announce.contactPhone}
                                                    onChange={onChangeAnnonce}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <div
                                                                style={{
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                {codeNum}
                                                            </div>
                                                        ),
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                             <Grid item lg={4} sm={3} xs={12}></Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                {t("annonce.labels.decrivez-comment-les-voyageurs")}
                                            </Grid>
                                             <Grid item lg={4} sm={3} xs={12}></Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <PropertyTextFieldMulitline
                                                    id="howToAccessDesc"
                                                    label={""}
                                                    name="howToAccessDesc"
                                                    value={announce.howToAccessDesc}
                                                    handleChange={onChangeAnnonce}
                                                    minRows={2}
                                                    upDatingProps={!isUpdating}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                         "listTable.labels.gpsLink"
                                                    )}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12} style={{ marginBottom: '10px' }}>
                                                <TextField
                                                    id="sponsorshipCode"
                                                    fullWidth
                                                    name="sponsorshipCode"
                                                    value={announce.sponsorshipCode}
                                                    InputProps={{
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>

                                            <Grid item lg={12} sm={12} xs={12} style={{ marginBottom: '10px' }}>
                                                {errorMessages && (
                                                    <div className={classes.errors}>
                                                        <Typography>
                                                            <Error />
                                                            <br />
                                                            <span>{errorMessages}</span>
                                                        </Typography>
                                                    </div>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        item
                                        lg={3}
                                        sm={12}
                                        className={classes.photosContainer}
                                    >
                                        <div>
                                            {!previewPhotos.length && (
                                                <h3>
                                                    {t("propriete.labels.aucunePhoto")}
                                                </h3>
                                            )}
                                            {previewPhotos.length && (
                                                <PreviewPhotos
                                                    photos={previewPhotos}
                                                    isUpdating={isUpdating}
                                                    idProperty={property._id || ""}
                                                    onDeletePhoto={onDeletePhoto}
                                                />
                                            )}
                                        </div>
                                        <div>
                                            <UploadPhotos
                                                handleChangePhotos={onChangePhoto}
                                                isUpdating={!isUpdating}
                                                selectedPhotos={newPhotos}
                                            />
                                        </div>

                                        <div
                                            className={
                                                classes.updateInfosButtonsContainer
                                            }
                                        >
                                            <Button
                                                className={classes.updateButton}
                                                onClick={
                                                    isUpdating
                                                        ? cancelUpdatingForm
                                                        : triggerUpdatingForm
                                                }
                                            >
                                                {isUpdating
                                                    ? `${t(
                                                        "propriete.labels.annuler-la-modification"
                                                    )}`
                                                    : `${t(
                                                        "propriete.labels.modifier"
                                                    )}`}
                                            </Button>

                                            {isUpdating && (
                                                <Button
                                                    size="small"
                                                    type="submit"
                                                    className={classes.button}
                                                    endIcon={loading ? <Spin /> : null}
                                                    disabled={loading}
                                                >
                                                    {t("propriete.buttonSave")}
                                                </Button>
                                            )}
                                        </div>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                        <AfriqSnackbar
                            {...snackValues}
                            handleClose={handleCloseSnackbar}
                        />
                    </div>
                </>
            )} 

            { (property.type?.searchType?.name === "cars" ) && (     
                <>    
                    <Typography
                        variant="h5"
                        gutterBottom
                        className={classes.propertiesTitle}
                    >
                        {t("label.modification-d-annonce")}
                    </Typography>
                    <div className={classes.editContainer}>
                        {loadingPage ? (
                            <CircularProgress size={32} style={{ color: "#890608" }} />
                        ) : (
                            <form
                                className={classes.root}
                                noValidate
                                autoComplete="off"
                                onSubmit={handleSubmit}
                            >
                                <Grid
                                    container
                                    spacing={2}
                                    style={{ justifyContent: "space-around" }}
                                >
                                    <Grid
                                        item
                                        lg={8}
                                        sm={12}
                                        className={classes.propertyInfosContainer}
                                    >
                                        <Grid container spacing={2}>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyCarName"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.nomDuVehicule"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyCarName"
                                                    fullWidth
                                                    name="name"
                                                    value={property.name}
                                                    onChange={onChangeHandler}
                                                    inputProps={{
                                                        readOnly: true, // Set to always read-only
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyBrand"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.carBrand"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <FormControl
                                                    variant="outlined"
                                                    fullWidth
                                                    style={{ marginBottom: "10px" }}
                                                >
                                                    <Select
                                                        id="carBrand"
                                                        labelId="carBrandLabel"
                                                        label={`${t("propriete.labels.carBrand")} *`}
                                                        name="vhcl_brand"
                                                        value={property.vhcl_brand ?? ""} // Controlled value
                                                        onChange={onChangeHandler} // Handler to update state
                                                        inputProps={{
                                                            readOnly: !isUpdating, // Make it read-only if not updating
                                                        }}
                                                    >
                                                        {carBrands.map((brand) => (
                                                            <MenuItem key={brand} value={brand}>
                                                                {brand}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyModel"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.carModel"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyModel"
                                                    fullWidth
                                                    name="vhcl_model"
                                                    value={property.vhcl_model}
                                                    onChange={onChangeHandler}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyPassengers"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.nombreMaximumPassengers"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyPassengers"
                                                    fullWidth
                                                    name="vhcl_passengers"
                                                    value={property.vhcl_passengers}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyFuelType"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.carFuel"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                                                    <Select
                                                        id="propertyFuelType"
                                                        name="vhcl_fuelType"
                                                        value={property.vhcl_fuelType} // Ensure a valid value is provided
                                                        onChange={onChangeHandler} // The function to handle the value change
                                                        disabled={!isUpdating} 
                                                    >
                                                        <MenuItem value="essence">{t('propriete.labels.essence')}</MenuItem>
                                                        <MenuItem value="diesel">{t('propriete.labels.diesel')}</MenuItem>
                                                        <MenuItem value="electric">{t('propriete.labels.electric')}</MenuItem>
                                                        <MenuItem value="hybrid">{t('propriete.labels.hybrid')}</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyBags"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.nombreDeBags"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyBags"
                                                    fullWidth
                                                    name="vhcl_bags"
                                                    value={property.vhcl_bags}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyDoors"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.nombreDeDoors"
                                                    )}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyDoors"
                                                    fullWidth
                                                    name="vhcl_doors"
                                                    value={property.vhcl_doors}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyGearBox"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.gearBox"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                                                    <Select
                                                        id="propertyGearBox"
                                                        name="vhcl_gearBox"
                                                        value={property.vhcl_gearBox} // Ensure a valid value is provided
                                                        onChange={onChangeHandler} // The function to handle the value change
                                                        disabled={!isUpdating} 
                                                    >
                                                        <MenuItem value="automatic">{t('propriete.labels.automatic')}</MenuItem>
                                                        <MenuItem value="manual">{t('propriete.labels.manual')}</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyEnginePower"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.enginePower")}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyEnginePower"
                                                    fullWidth
                                                    name="vhcl_enginePower"
                                                    value={property.vhcl_enginePower}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                           
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyPlaqueId"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.plaqueID"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyPlaqueId"
                                                    fullWidth
                                                    name="vhcl_plaqueId"
                                                    value={property.vhcl_plaqueId}
                                                    onChange={onChangeHandler}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyChassisId"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.chassis"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyChassisId"
                                                    fullWidth
                                                    name="vhcl_chassisId"
                                                    value={property.vhcl_chassisId}
                                                    onChange={onChangeHandler}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid> 
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyYear"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.carYear"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>                                           
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyYear"
                                                    fullWidth
                                                    name="vhcl_year"
                                                    value={property.vhcl_year}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyKilometers"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.kilometrageInitial"
                                                    )}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyKilometers"
                                                    fullWidth
                                                    name="vhcl_kilometers"
                                                    value={property.vhcl_kilometers}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyExtColor"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.couleurExterne"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                                                    <Select
                                                        id="propertyExtColor"
                                                        labelId="propertyExtColorLabel"
                                                        label={`${t('propriete.labels.couleurExterne')} * :`}
                                                        name="vhcl_color"
                                                        value={property.vhcl_color} 
                                                        onChange={onChangeHandler} 
                                                        disabled={!isUpdating}

                                                    >
                                                        <MenuItem value="noir">{t('propriete.options.couleurs.noir')}</MenuItem>
                                                        <MenuItem value="blanc">{t('propriete.options.couleurs.blanc')}</MenuItem>
                                                        <MenuItem value="gris">{t('propriete.options.couleurs.gris')}</MenuItem>
                                                        <MenuItem value="rouge">{t('propriete.options.couleurs.rouge')}</MenuItem>
                                                        <MenuItem value="bleu">{t('propriete.options.couleurs.bleu')}</MenuItem>
                                                        <MenuItem value="vert">{t('propriete.options.couleurs.vert')}</MenuItem>
                                                        <MenuItem value="argent">{t('propriete.options.couleurs.argent')}</MenuItem>
                                                        <MenuItem value="or">{t('propriete.options.couleurs.or')}</MenuItem>
                                                        <MenuItem value="marron">{t('propriete.options.couleurs.marron')}</MenuItem>
                                                        <MenuItem value="jaune">{t('propriete.options.couleurs.jaune')}</MenuItem>
                                                        <MenuItem value="bordeaux">{t('propriete.options.couleurs.bordeaux')}</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertySeatFabric"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.seatFabric"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                                                    <Select
                                                        id="propertySeatFabric"
                                                        labelId="propertySeatFabricLabel"
                                                        label={`${t('propriete.labels.seatFabric')} * :`}
                                                        name="vhcl_seatFabric"
                                                        value={property.vhcl_seatFabric} // Controlled value
                                                        onChange={onChangeHandler} // Update state via handler
                                                        disabled={!isUpdating}
                                                    >
                                                        <MenuItem value="cuir">{t('propriete.options.seatFabric.cuir')}</MenuItem>
                                                        <MenuItem value="tissu">{t('propriete.options.seatFabric.tissu')}</MenuItem>
                                                        <MenuItem value="alcantara">{t('propriete.options.seatFabric.alcantara')}</MenuItem>
                                                        <MenuItem value="vinyle">{t('propriete.options.seatFabric.vinyle')}</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyIntColor"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.couleurInterne"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                                                    <Select
                                                        id="propertyIntColor"
                                                        labelId="propertyIntColorLabel"
                                                        label={`${t('propriete.labels.couleurInterne')} * :`}
                                                        name="vhcl_interiorColor"
                                                        value={property.vhcl_interiorColor} // Controlled value
                                                        onChange={onChangeHandler} // Update state via handler
                                                        disabled={!isUpdating}
                                                    >
                                                        <MenuItem value="noir">{t('propriete.options.couleurs.noir')}</MenuItem>
                                                        <MenuItem value="blanc">{t('propriete.options.couleurs.blanc')}</MenuItem>
                                                        <MenuItem value="beige">{t('propriete.options.couleurs.beige')}</MenuItem>
                                                        <MenuItem value="gris">{t('propriete.options.couleurs.gris')}</MenuItem>
                                                        <MenuItem value="marron">{t('propriete.options.couleurs.marron')}</MenuItem>
                                                        <MenuItem value="rouge">{t('propriete.options.couleurs.rouge')}</MenuItem>
                                                        <MenuItem value="bleu">{t('propriete.options.couleurs.bleu')}</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyInsuranceProvider"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.insuranceProvider"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyInsuranceProvider"
                                                    fullWidth
                                                    name="vhcl_insuranceProvider"
                                                    value={property.vhcl_insuranceProvider}
                                                    onChange={onChangeHandler}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid> 
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="insurance-expiry-date"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.insuranceExpiryDate"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="insurance-expiry-date"
                                                    variant="outlined"
                                                    type="date"
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    value={
                                                        property.vhcl_insuranceExpiryDate && !isNaN(new Date(property.vhcl_insuranceExpiryDate).getTime())
                                                            ? new Date(property.vhcl_insuranceExpiryDate).toISOString().split("T")[0]
                                                            : ""
                                                    }
                                                    onChange={(event) => {
                                                        const newDate = new Date(event.target.value);
                                                        if (!isNaN(newDate.getTime())) {
                                                            // Update the state only if the date is valid
                                                            onChangeHandler({
                                                                target: {
                                                                    name: "vhcl_insuranceExpiryDate",
                                                                    value: newDate.toISOString().split("T")[0], // Keep the date in YYYY-MM-DD format
                                                                },
                                                            });
                                                        }
                                                    }}
                                                    inputProps={{
                                                        readOnly: !isUpdating, // Restrict the field from being edited if not updating
                                                    }}
                                                    style={{
                                                        width: '33%',
                                                        borderRadius: 8, // Rounded corners for the input
                                                    }}
                                                />
                                            </Grid> 
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyEquipments"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.equipements")}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            
                                            <Grid item lg={8} sm={9} xs={12} className={classes.inpuText}>
                                                <Grid container>
                                                    {tab_eq.map((cat: any) => {
                                                        return (
                                                            <>
                                                                <Grid item xs={12} className={classes.category}>
                                                                    <span>{cat.categorie}</span>
                                                                </Grid>
                                                                {cat.equipement.map((eq: IEquipment) => {
                                                                    const equipmentName = i18n.language === "fr" ? eq.name?.fr : eq.name?.en;

                                                                    // Check if the current equipment is selected by checking in `equipmentsSelected`
                                                                    const isChecked = equipmentsSelected.some((selectedEq) => selectedEq._id === eq._id);

                                                                    return (
                                                                        <Grid
                                                                            item
                                                                            lg={4}
                                                                            md={4}
                                                                            sm={4}
                                                                            xs={6}
                                                                            key={eq._id}
                                                                        >
                                                                            <CheckableTreeItem
                                                                                onChecked={isUpdating ? () => handleCheck(eq) : undefined}
                                                                                checkable
                                                                                node={{
                                                                                    label: (
                                                                                        <span style={{ color: "#999", fontSize: "smaller" }}>
                                                                                            {equipmentName}
                                                                                        </span>
                                                                                    ),
                                                                                    // Set the checkbox checked state based on whether it's selected
                                                                                    checked: isChecked,
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    );
                                                                })}

                                                            </>
                                                        );
                                                    })}
                                                </Grid>
                                            </Grid>                                          
                                            
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyCountry"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.pays")}* :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <Select
                                                    id="propertyType"
                                                    name="name"
                                                    fullWidth
                                                    value={property.address.country?.name}
                                                    onChange={
                                                        onChangePropertyPaysHandler
                                                    }
                                                    autoFocus
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                >
                                                    {paysList &&
                                                        paysList.map(
                                                            (
                                                                type: any,
                                                                index: number
                                                            ) => (
                                                                <MenuItem
                                                                    value={type.name}
                                                                    key={type._id}
                                                                >
                                                                    {type.name}
                                                                </MenuItem>
                                                            )
                                                        )}
                                                </Select>
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyCountry"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.nomDeLaVille")}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <Select
                                                    id="propertyType"
                                                    name="city"
                                                    fullWidth
                                                    value={address.city?.name}
                                                    onChange={
                                                        onChangePropertyVilleHandler
                                                    }
                                                    autoFocus
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                >
                                                    {tabPays &&
                                                        tabPays.map(
                                                            (
                                                                type: any,
                                                                index: number
                                                            ) => (
                                                                <MenuItem
                                                                    value={type.name}
                                                                    key={type.name}
                                                                >
                                                                    {type.name}
                                                                </MenuItem>
                                                            )
                                                        )}
                                                </Select>
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyZipCode"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.codePostal")} :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyZipCode"
                                                    fullWidth
                                                    name="zipcode"
                                                    value={address.zipcode}
                                                    onChange={onChangeAddress}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="properState"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.etatOuProvince"
                                                    )}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="properState"
                                                    fullWidth
                                                    name="state"
                                                    value={address.state}
                                                    onChange={onChangeAddress}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="properState"
                                                    className={classes.label}
                                                >
                                                    {t("listTable.labels.quartier")}* :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="properState"
                                                    fullWidth
                                                    name="quartier"
                                                    value={address.quartier}
                                                    onChange={onChangeAddress}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    Description
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <DescriptionRichText
                                                    handleChange={onChangeAnnonce}
                                                    isCanceled={!isUpdating}
                                                    description={announce.description}
                                                    readOnly={!isUpdating}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t("annonce.labels.tarif-de-base")}{" "}
                                                    ({announce.devise})* :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePrice"
                                                    fullWidth
                                                    name="price"
                                                    value={announce.price}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                        "annonce.labels.tarif-hebdomadaire"
                                                    )}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceWeekly"
                                                    fullWidth
                                                    name="priceWeekly"
                                                    value={announce.priceWeekly}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                        "annonce.labels.tarif-hebdomadaire-par-jour"
                                                    )}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceWeeklyDaily"
                                                    fullWidth
                                                    name="priceWeeklyDaily"
                                                    value={priceWeeklyDaily}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                        "annonce.labels.tarif-de-quinzaine"
                                                    )}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceBiWeekly"
                                                    fullWidth
                                                    name="priceBiWeekly"
                                                    value={announce.priceBiWeekly}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                        "annonce.labels.tarif-de-quinzaine-par-jour"
                                                    )}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceBiWeeklyDaily"
                                                    fullWidth
                                                    name="priceBiWeeklyDaily"
                                                    value={priceBiWeeklyDaily}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t("annonce.labels.tarif-mensuel")}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceMonthly"
                                                    fullWidth
                                                    name="priceMonthly"
                                                    value={announce.priceMonthly}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                        "annonce.labels.tarif-mensuel-par-jour"
                                                    )}{" "}
                                                    ({announce.devise}) :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePriceMonthlyDaily"
                                                    fullWidth
                                                    name="priceMonthlyDaily"
                                                    value={priceMonthlyDaily}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={
                                                        onChangeSpecialPriceAnnounce
                                                    }
                                                />
                                            </Grid>   

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="account_paypal"
                                                    className={classes.label}
                                                >
                                                    {`${t("label.compte-paypal")} : `}
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="account_paypal"
                                                    fullWidth
                                                    name="account_paypal"
                                                    value={announce.account_paypal}
                                                    InputProps={{
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>
                                            {address.country?.name === "Cameroon" && (
                                                <>
                                                    <Grid item lg={4} sm={3} xs={12}>
                                                        <label
                                                            htmlFor="account_orange"
                                                            className={classes.label}
                                                        >
                                                            {`${t(
                                                                "label.compte-orange"
                                                            )} : `}
                                                        </label>
                                                    </Grid>
                                                    <Grid item lg={8} sm={9} xs={12}>
                                                        <TextField
                                                            id="account_orange"
                                                            fullWidth
                                                            name="account_orange"
                                                            value={
                                                                announce.account_orange
                                                            }
                                                            onChange={onChangeAnnonce}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <div
                                                                        style={{
                                                                            marginRight: 10,
                                                                        }}
                                                                    >
                                                                        {codeNum}
                                                                    </div>
                                                                ),
                                                                inputProps: {
                                                                    readOnly:
                                                                        !isUpdating,
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={4} sm={3} xs={12}>
                                                        <label
                                                            htmlFor="account_mtn"
                                                            className={classes.label}
                                                        >
                                                            {`${t(
                                                                "label.compte-mtn"
                                                            )} : `}
                                                        </label>
                                                    </Grid>
                                                    <Grid item lg={8} sm={9} xs={12}>
                                                        <TextField
                                                            id="account_mtn"
                                                            fullWidth
                                                            name="account_mtn"
                                                            value={announce.account_mtn}
                                                            onChange={onChangeAnnonce}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <div
                                                                        style={{
                                                                            marginRight: 10,
                                                                        }}
                                                                    >
                                                                        {codeNum}
                                                                    </div>
                                                                ),
                                                                inputProps: {
                                                                    readOnly:
                                                                        !isUpdating,
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    
                                                    <Grid item lg={4} sm={3} xs={12}>
                                                        <label
                                                            htmlFor="favoritePaymentMethod"
                                                            className={classes.label}
                                                        >
                                                            {t(
                                                                "label.favoritePaymentMethod"
                                                            )}{" "}
                                                            :
                                                        </label>
                                                    </Grid>
                                                    <Grid item lg={8} sm={9} xs={12}>
                                                        <Select
                                                            id="favoritePaymentMethod"
                                                            name="favoritePaymentMethod"
                                                            fullWidth
                                                            value={
                                                                announce.favoritePaymentMethod
                                                            }
                                                            onChange={onChangeAnnonce}
                                                            autoFocus
                                                            inputProps={{
                                                                readOnly: !isUpdating,
                                                            }}
                                                        >
                                                            {paymentMethodMobileList.map(
                                                                (method) => (
                                                                    <MenuItem
                                                                        value={
                                                                            method.value
                                                                        }
                                                                        key={
                                                                            method.label +
                                                                            method.value
                                                                        }
                                                                    >
                                                                        {method.label}
                                                                    </MenuItem>
                                                                )
                                                            )}
                                                        </Select>
                                                    </Grid>
                                                </>
                                            )}

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <span>Checkin:</span>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TimePicker
                                                    value={checkin}
                                                    onChange={handleValueChange}
                                                    showSecond={false}
                                                    allowEmpty
                                                    disabled={!isUpdating}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <span>Checkout:</span>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TimePicker
                                                    value={checkout}
                                                    onChange={handleValueChangeOut}
                                                    showSecond={false}
                                                    allowEmpty
                                                    disabled={!isUpdating}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    className={classes.label}
                                                    htmlFor="rules"
                                                >
                                                    {t("label.reglements-interieurs")} :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <PropertyTextFieldMulitline
                                                    id="rules"
                                                    label={""}
                                                    name="rules"
                                                    value={announce.rules}
                                                    handleChange={onChangeAnnonce}
                                                    minRows={2}
                                                    upDatingProps={!isUpdating}
                                                />
                                                <Grid item lg={4} sm={3} xs={12}>
                                                    <label
                                                        className={classes.label}
                                                        htmlFor="cancellationPolicyText"
                                                    >
                                                        {t(
                                                            "annonce.labels.politiqueDAnnulation"
                                                        )}
                                                    </label>
                                                </Grid>
                                                <Grid item lg={8} sm={9} xs={12}>
                                                    <PropertyTextFieldMulitline
                                                        id="cancellationPolicyText"
                                                        label={""}
                                                        name="cancellationPolicy"
                                                        value={announce.cancellationPolicy}
                                                        handleChange={onChangeAnnonce}
                                                        minRows={2}
                                                        upDatingProps={!isUpdating}
                                                    />
                                                </Grid>
                                                <RadioGroup
                                                    row
                                                    aria-label="position"
                                                    value={valueGroup}
                                                    onChange={handleChangeGroup}
                                                >
                                                    <FormControlLabel
                                                        value="remboursable"
                                                        control={
                                                            <Radio color="primary" />
                                                        }
                                                        label={t(
                                                            "annonce.remborse-titre"
                                                        )}
                                                        disabled={!isUpdating}
                                                        style={{ fontSize: "inherit" }}
                                                        labelPlacement="end"
                                                    />
                                                    <div>
                                                        <p className={classes.annuler}>
                                                            <span
                                                                style={{
                                                                    whiteSpace:
                                                                        "nowrap",
                                                                }}
                                                            >
                                                                {" "}
                                                                1-{" "}
                                                                {t(
                                                                    "detail-annonce.refundItem11"
                                                                )}{" "}
                                                            </span>
                                                            <SelectEndornmentNationPolitique
                                                                id="country"
                                                                name="freeRefundDay"
                                                                values={tabN}
                                                                selectedValue={
                                                                    announce.freeRefundDay
                                                                }
                                                                remboursable={
                                                                    valueGroup
                                                                }
                                                                handleOnChange={
                                                                    handleOnChangeSelect
                                                                }
                                                                isUpdating={!isUpdating}
                                                            />
                                                            <span
                                                                style={{
                                                                    marginLeft: 10,
                                                                }}
                                                            >
                                                                {" "}
                                                                {t(
                                                                    "detail-annonce.refundItem12"
                                                                )}
                                                                .
                                                            </span>
                                                        </p>{" "}
                                                        <br />
                                                        <p className={classes.annuler}>
                                                            <span
                                                                style={{
                                                                    whiteSpace:
                                                                        "nowrap",
                                                                }}
                                                            >
                                                                2-{" "}
                                                                {t(
                                                                    "detail-annonce.refundItem21"
                                                                )}
                                                            </span>
                                                            {announce.freeRefundDay}
                                                            <span
                                                                style={{
                                                                    marginLeft: 10,
                                                                }}
                                                            >
                                                                {t(
                                                                    "detail-annonce.refundItem22"
                                                                )}
                                                            </span>
                                                            <SelectEndornmentNationPolitique
                                                                id="country"
                                                                name="penaltyDayFees"
                                                                values={tabN}
                                                                selectedValue={
                                                                    announce.penaltyDayFees
                                                                }
                                                                remboursable={
                                                                    valueGroup
                                                                }
                                                                handleOnChange={
                                                                    handleOnChangeSelect
                                                                }
                                                                isUpdating={!isUpdating}
                                                            />
                                                            <span
                                                                style={{
                                                                    marginLeft: 10,
                                                                }}
                                                            >
                                                                {t(
                                                                    "detail-annonce.refundItem23"
                                                                )}{" "}
                                                                .{" "}
                                                            </span>
                                                        </p>
                                                        <br />
                                                        <p className={classes.annuler}>
                                                            <span
                                                                style={{
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                3-{" "}
                                                                {t(
                                                                    "detail-annonce.refundItem31"
                                                                )}
                                                            </span>
                                                            <SelectEndornmentNationPolitique
                                                                id="country"
                                                                name="penaltyDayFeesAfterBookingStarted"
                                                                values={tabN}
                                                                remboursable={
                                                                    valueGroup
                                                                }
                                                                selectedValue={
                                                                    announce.penaltyDayFeesAfterBookingStarted
                                                                }
                                                                handleOnChange={
                                                                    handleOnChangeSelect
                                                                }
                                                                isUpdating={!isUpdating}
                                                            />
                                                            <span
                                                                style={{
                                                                    marginLeft: 10,
                                                                }}
                                                            ></span>
                                                            {t(
                                                                "detail-annonce.refundItem32"
                                                            )}
                                                        </p>
                                                    </div>
                                                    <FormControlLabel
                                                        value="noremboursable"
                                                        control={
                                                            <Radio color="primary" />
                                                        }
                                                        label={t(
                                                            "annonce.option-not-remb"
                                                        )}
                                                        style={{ fontSize: "inherit" }}
                                                        disabled={!isUpdating}
                                                        labelPlacement="end"
                                                    />
                                                    <div>
                                                        <p className={classes.annuler}>
                                                            <span
                                                                style={{
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                1-{" "}
                                                                {t("annonce.not-remb1")}
                                                                <SelectEndornmentNationPolitiqueNoremb
                                                                    id="country"
                                                                    name="notRemboursable1"
                                                                    values={tabN}
                                                                    selectedValue={
                                                                        announce?.notRemboursable1
                                                                    }
                                                                    remboursable={
                                                                        valueGroup
                                                                    }
                                                                    handleOnChange={
                                                                        handleOnChangeSelect
                                                                    }
                                                                    isUpdating={
                                                                        !isUpdating
                                                                    }
                                                                />{" "}
                                                                {t("annonce.not-remb2")}
                                                            </span>
                                                        </p>
                                                        <p className={classes.annuler}>
                                                            <span
                                                                style={{
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                2-{" "}
                                                                {t("annonce.not-remb3")}
                                                                {
                                                                    announce?.notRemboursable1
                                                                }
                                                                {t("annonce.not-remb4")}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </RadioGroup>
                                            </Grid>
                                            <Grid item lg={12} sm={12} xs={12}></Grid>
                                            
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="contactName"
                                                    className={classes.label}
                                                >
                                                    {t("annonce.labels.nom-du-contact")}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="contactName"
                                                    fullWidth
                                                    name="contactName"
                                                    value={announce.contactName}
                                                    InputProps={{
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="contactPhone"
                                                    className={classes.label}
                                                >
                                                    {`${t(
                                                        "annonce.labels.numero-du-contact"
                                                    )} : `}
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="contactPhone"
                                                    fullWidth
                                                    name="contactPhone"
                                                    value={announce.contactPhone}
                                                    onChange={onChangeAnnonce}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <div
                                                                style={{
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                {codeNum}
                                                            </div>
                                                        ),
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="decrivez"
                                                    className={classes.label}
                                                >
                                                 ""
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <label
                                                    htmlFor="decrivez"
                                                    className={classes.label}
                                                >
                                                 {t("annonce.labels.decrivez-comment-les-voyageurs")}
                                                </label>
                                            </Grid>     
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="howToAccessDesc"
                                                    className={classes.label}
                                                >
                                                 ''
                                                </label>
                                            </Grid>                                          
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <PropertyTextFieldMulitline
                                                    id="howToAccessDesc"
                                                    label={""}
                                                    name="howToAccessDesc"
                                                    value={announce.howToAccessDesc}
                                                    handleChange={onChangeAnnonce}
                                                    minRows={2}
                                                    upDatingProps={!isUpdating}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12} >
                                                <label className={classes.label}>
                                                    {t(
                                                        "listTable.labels.gpsLink"
                                                    )}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12} style={{ marginBottom: '10px' }}>
                                                <TextField
                                                    id="sponsorshipCode"
                                                    fullWidth
                                                    name="sponsorshipCode"
                                                    value={announce.sponsorshipCode}
                                                    InputProps={{
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>

                                            <Grid item lg={12} sm={12} xs={12} style={{ marginBottom: '10px' }}>
                                                {errorMessages && (
                                                    <div className={classes.errors}>
                                                        <Typography>
                                                            <Error />
                                                            <br />
                                                            <span>{errorMessages}</span>
                                                        </Typography>
                                                    </div>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        item
                                        lg={3}
                                        sm={12}
                                        className={classes.photosContainer}
                                    >
                                        <div>
                                            {!previewPhotos.length && (
                                                <h3>
                                                    {t("propriete.labels.aucunePhoto")}
                                                </h3>
                                            )}
                                            {previewPhotos.length && (
                                                <PreviewPhotos
                                                    photos={previewPhotos}
                                                    isUpdating={isUpdating}
                                                    idProperty={property._id || ""}
                                                    onDeletePhoto={onDeletePhoto}
                                                />
                                            )}
                                        </div>
                                        <div>
                                            <UploadPhotos
                                                handleChangePhotos={onChangePhoto}
                                                isUpdating={!isUpdating}
                                                selectedPhotos={newPhotos}
                                            />
                                        </div>

                                        <div
                                            className={
                                                classes.updateInfosButtonsContainer
                                            }
                                        >
                                            <Button
                                                className={classes.updateButton}
                                                onClick={
                                                    isUpdating
                                                        ? cancelUpdatingForm
                                                        : triggerUpdatingForm
                                                }
                                            >
                                                {isUpdating
                                                    ? `${t(
                                                        "propriete.labels.annuler-la-modification"
                                                    )}`
                                                    : `${t(
                                                        "propriete.labels.modifier"
                                                    )}`}
                                            </Button>

                                            {isUpdating && (
                                                <Button
                                                    size="small"
                                                    type="submit"
                                                    className={classes.button}
                                                    endIcon={loading ? <Spin /> : null}
                                                    disabled={loading}
                                                >
                                                    {t("propriete.buttonSave")}
                                                </Button>
                                            )}
                                        </div>
                                    </Grid>
                                </Grid>
                               
                            </form>
                        )}
                        <AfriqSnackbar
                            {...snackValues}
                            handleClose={handleCloseSnackbar}
                        />
                    </div>
                </>
            )} 

             { (property.type?.searchType?.name === "rstt" ) && (     
                <>    
                    <Typography
                        variant="h5"
                        gutterBottom
                        className={classes.propertiesTitle}
                    >
                        {t("label.modification-d-annonce")}
                    </Typography>
                    <div className={classes.editContainer}>
                        {loadingPage ? (
                            <CircularProgress size={32} style={{ color: "#890608" }} />
                        ) : (
                            <form
                                className={classes.root}
                                noValidate
                                autoComplete="off"
                                onSubmit={handleSubmit}
                            >
                                <Grid
                                    container
                                    spacing={2}
                                    style={{ justifyContent: "space-around" }}
                                >
                                    <Grid
                                        item
                                        lg={8}
                                        sm={12}
                                        className={classes.propertyInfosContainer}
                                    >
                                        <Grid container spacing={2}>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyName"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.nomDeLaPropriete"
                                                    )}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <Select
                                                    id="propertyName"
                                                    name="name"
                                                    fullWidth
                                                    value={property.type ? property.type._id : ""}
                                                    onChange={
                                                        onChangePropertyTypeHandler
                                                    }
                                                    autoFocus
                                                    inputProps={{ readOnly: true }}
                                                >
                                                    {propertyTypeList.map(
                                                        (
                                                            type: IPropertyType,
                                                            index: number
                                                        ) => (
                                                            <MenuItem
                                                                value={type._id}
                                                                key={type._id}
                                                            >
                                                                {type.label
                                                                    ? t(type.label)
                                                                    : type.name}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyName"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.nomDeLaPropriete"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyName"
                                                    fullWidth
                                                    name="name"
                                                    value={property.name}
                                                    onChange={onChangeHandler}
                                                    inputProps={{
                                                        readOnly: true, // Set to always read-only
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="rstt_typeAnnonce"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.rstt_typeAnnonce"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <FormControl variant="outlined" fullWidth style={{ marginBottom: '10px' }}>
                                                    <Select
                                                        id="rstt_typeAnnonce"
                                                        name="rstt_typeAnnonce"
                                                        value={property.rstt_typeAnnonce} // Ensure a valid value is provided
                                                        onChange={onChangeHandler} // The function to handle the value change
                                                    >
                                                        <MenuItem value="rental">{t('propriete.labels.rental')}</MenuItem>
                                                        <MenuItem value="sale">{t('propriete.labels.sale')}</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="rstt_numberOfBedrooms"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.rstt_numberOfBedrooms"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="rstt_numberOfBedrooms"
                                                    fullWidth
                                                    name="rstt_numberOfBedrooms"
                                                    value={property.rstt_numberOfBedrooms}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="rstt_numberOfBathrooms"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.rstt_numberOfBathrooms"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="rstt_numberOfBathrooms"
                                                    fullWidth
                                                    name="rstt_numberOfBathrooms"
                                                    value={property.rstt_numberOfBathrooms}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="rstt_surfaceHabitable"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.surfaceHabitable"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="rstt_surfaceHabitable"
                                                    fullWidth
                                                    name=".rstt_surfaceHabitable"
                                                    value={property.rstt_surfaceHabitable}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="rstt_superficieTerrain"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.superficieTerrain"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="rstt_superficieTerrain"
                                                    fullWidth
                                                    name="rstt_superficieTerrain"
                                                    value={property.rstt_superficieTerrain}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="rstt_superficieTerrain"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.rstt_yearBuilt"
                                                    )}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="rstt_yearBuilt"
                                                    fullWidth
                                                    name="rstt_yearBuilt"
                                                    value={property.rstt_yearBuilt}
                                                    type="number"
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 25,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeHandler}
                                                />
                                            </Grid>
                                            
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyEquipments"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.equipements")}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12} className={classes.inpuText}>
                                                <Grid container>
                                                    {tab_eq.map((cat: any) => {
                                                        return (
                                                            <>
                                                                <Grid item xs={12} className={classes.category}>
                                                                    <span>{cat.categorie}</span>
                                                                </Grid>
                                                                {cat.equipement.map((eq: IEquipment) => {
                                                                    const equipmentName = i18n.language === "fr" ? eq.name?.fr : eq.name?.en;

                                                                    // Check if the current equipment is selected by checking in `equipmentsSelected`
                                                                    const isChecked = equipmentsSelected.some((selectedEq) => selectedEq._id === eq._id);

                                                                    return (
                                                                        <Grid
                                                                            item
                                                                            lg={4}
                                                                            md={4}
                                                                            sm={4}
                                                                            xs={6}
                                                                            key={eq._id}
                                                                        >
                                                                            <CheckableTreeItem
                                                                                onChecked={isUpdating ? () => handleCheck(eq) : undefined}
                                                                                checkable
                                                                                node={{
                                                                                    label: (
                                                                                        <span style={{ color: "#999", fontSize: "smaller" }}>
                                                                                            {equipmentName}
                                                                                        </span>
                                                                                    ),
                                                                                    // Set the checkbox checked state based on whether it's selected
                                                                                    checked: isChecked,
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    );
                                                                })}
                                                            </>
                                                        );
                                                    })}
                                                </Grid>
                                            </Grid>
                                                
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyCountry"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.pays")}* :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <Select
                                                    id="propertyType"
                                                    name="name"
                                                    fullWidth
                                                    value={property.address.country?.name}
                                                    onChange={
                                                        onChangePropertyPaysHandler
                                                    }
                                                    autoFocus
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                >
                                                    {paysList &&
                                                        paysList.map(
                                                            (
                                                                type: any,
                                                                index: number
                                                            ) => (
                                                                <MenuItem
                                                                    value={type.name}
                                                                    key={type._id}
                                                                >
                                                                    {type.name}
                                                                </MenuItem>
                                                            )
                                                        )}
                                                </Select>
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyCountry"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.nomDeLaVille")}
                                                    * :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <Select
                                                    id="propertyType"
                                                    name="city"
                                                    fullWidth
                                                    value={address.city?.name}
                                                    onChange={
                                                        onChangePropertyVilleHandler
                                                    }
                                                    autoFocus
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                >
                                                    {tabPays &&
                                                        tabPays.map(
                                                            (
                                                                type: any,
                                                                index: number
                                                            ) => (
                                                                <MenuItem
                                                                    value={type.name}
                                                                    key={type.name}
                                                                >
                                                                    {type.name}
                                                                </MenuItem>
                                                            )
                                                        )}
                                                </Select>
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="propertyZipCode"
                                                    className={classes.label}
                                                >
                                                    {t("propriete.labels.codePostal")} :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="propertyZipCode"
                                                    fullWidth
                                                    name="zipcode"
                                                    value={address.zipcode}
                                                    onChange={onChangeAddress}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="properState"
                                                    className={classes.label}
                                                >
                                                    {t(
                                                        "propriete.labels.etatOuProvince"
                                                    )}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="properState"
                                                    fullWidth
                                                    name="state"
                                                    value={address.state}
                                                    onChange={onChangeAddress}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="properState"
                                                    className={classes.label}
                                                >
                                                    {t("listTable.labels.quartier")}* :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="properState"
                                                    fullWidth
                                                    name="quartier"
                                                    value={address.quartier}
                                                    onChange={onChangeAddress}
                                                    inputProps={{
                                                        readOnly: !isUpdating,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    Description
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <DescriptionRichText
                                                    handleChange={onChangeAnnonce}
                                                    isCanceled={!isUpdating}
                                                    description={announce.description}
                                                    readOnly={!isUpdating}
                                                />
                                            </Grid>

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t("label.détail-du-prix")}{" "}
                                                    ({announce.devise})* :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="announcePrice"
                                                    fullWidth
                                                    name="price"
                                                    value={announce.price}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>

                                           
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="account_paypal"
                                                    className={classes.label}
                                                >
                                                    {`${t("label.compte-paypal")} : `}
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="account_paypal"
                                                    fullWidth
                                                    name="account_paypal"
                                                    value={announce.account_paypal}
                                                    InputProps={{
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>
                                            {address.country?.name === "Cameroon" && (
                                                <>
                                                    <Grid item lg={4} sm={3} xs={12}>
                                                        <label
                                                            htmlFor="account_orange"
                                                            className={classes.label}
                                                        >
                                                            {`${t(
                                                                "label.compte-orange"
                                                            )} : `}
                                                        </label>
                                                    </Grid>
                                                    <Grid item lg={8} sm={9} xs={12}>
                                                        <TextField
                                                            id="account_orange"
                                                            fullWidth
                                                            name="account_orange"
                                                            value={
                                                                announce.account_orange
                                                            }
                                                            onChange={onChangeAnnonce}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <div
                                                                        style={{
                                                                            marginRight: 10,
                                                                        }}
                                                                    >
                                                                        {codeNum}
                                                                    </div>
                                                                ),
                                                                inputProps: {
                                                                    readOnly:
                                                                        !isUpdating,
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={4} sm={3} xs={12}>
                                                        <label
                                                            htmlFor="account_mtn"
                                                            className={classes.label}
                                                        >
                                                            {`${t(
                                                                "label.compte-mtn"
                                                            )} : `}
                                                        </label>
                                                    </Grid>
                                                    <Grid item lg={8} sm={9} xs={12}>
                                                        <TextField
                                                            id="account_mtn"
                                                            fullWidth
                                                            name="account_mtn"
                                                            value={announce.account_mtn}
                                                            onChange={onChangeAnnonce}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <div
                                                                        style={{
                                                                            marginRight: 10,
                                                                        }}
                                                                    >
                                                                        {codeNum}
                                                                    </div>
                                                                ),
                                                                inputProps: {
                                                                    readOnly:
                                                                        !isUpdating,
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    
                                                    <Grid item lg={4} sm={3} xs={12}>
                                                        <label
                                                            htmlFor="favoritePaymentMethod"
                                                            className={classes.label}
                                                        >
                                                            {t(
                                                                "label.favoritePaymentMethod"
                                                            )}{" "}
                                                            :
                                                        </label>
                                                    </Grid>
                                                    <Grid item lg={8} sm={9} xs={12}>
                                                        <Select
                                                            id="favoritePaymentMethod"
                                                            name="favoritePaymentMethod"
                                                            fullWidth
                                                            value={
                                                                announce.favoritePaymentMethod
                                                            }
                                                            onChange={onChangeAnnonce}
                                                            autoFocus
                                                            inputProps={{
                                                                readOnly: !isUpdating,
                                                            }}
                                                        >
                                                            {paymentMethodMobileList.map(
                                                                (method) => (
                                                                    <MenuItem
                                                                        value={
                                                                            method.value
                                                                        }
                                                                        key={
                                                                            method.label +
                                                                            method.value
                                                                        }
                                                                    >
                                                                        {method.label}
                                                                    </MenuItem>
                                                                )
                                                            )}
                                                        </Select>
                                                    </Grid>
                                                </>
                                            )}

                                            <Grid item lg={4} sm={3} xs={12}>
                                                <span>Checkin:</span>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TimePicker
                                                    value={checkin}
                                                    onChange={handleValueChange}
                                                    showSecond={false}
                                                    allowEmpty
                                                    disabled={!isUpdating}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <span>Checkout:</span>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TimePicker
                                                    value={checkout}
                                                    onChange={handleValueChangeOut}
                                                    showSecond={false}
                                                    allowEmpty
                                                    disabled={!isUpdating}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    className={classes.label}
                                                    htmlFor="rules"
                                                >
                                                    {t("label.reglements-interieurs")} :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <PropertyTextFieldMulitline
                                                    id="rules"
                                                    label={""}
                                                    name="rules"
                                                    value={announce.rules}
                                                    handleChange={onChangeAnnonce}
                                                    minRows={2}
                                                    upDatingProps={!isUpdating}
                                                />                                               
                                            </Grid>                                       
                                                                                        
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t("annonce.labels.nom-du-contact")}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="contactName"
                                                    fullWidth
                                                    name="contactName"
                                                    value={announce.contactName}
                                                    InputProps={{
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label
                                                    htmlFor="contactPhone"
                                                    className={classes.label}
                                                >
                                                    {`${t(
                                                        "annonce.labels.numero-du-contact"
                                                    )} : `}
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <TextField
                                                    id="contactPhone"
                                                    fullWidth
                                                    name="contactPhone"
                                                    value={announce.contactPhone}
                                                    onChange={onChangeAnnonce}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <div
                                                                style={{
                                                                    marginRight: 10,
                                                                }}
                                                            >
                                                                {codeNum}
                                                            </div>
                                                        ),
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}></Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                              {t("annonce.labels.decrivez-comment-immobilier")}
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}></Grid>
                                            <Grid item lg={8} sm={9} xs={12}>
                                                <PropertyTextFieldMulitline
                                                    id="howToAccessDesc"
                                                    label={""}
                                                    name="howToAccessDesc"
                                                    value={announce.howToAccessDesc}
                                                    handleChange={onChangeAnnonce}
                                                    minRows={2}
                                                    upDatingProps={!isUpdating}
                                                />
                                            </Grid>
                                            <Grid item lg={4} sm={3} xs={12}>
                                                <label className={classes.label}>
                                                    {t(
                                                        "listTable.labels.gpsLink"
                                                    )}{" "}
                                                    :
                                                </label>
                                            </Grid>
                                            <Grid item lg={8} sm={9} xs={12} style={{ marginBottom: '10px' }}>
                                                <TextField
                                                    id="sponsorshipCode"
                                                    fullWidth
                                                    name="sponsorshipCode"
                                                    value={announce.sponsorshipCode}
                                                    InputProps={{
                                                        inputProps: {
                                                            readOnly: !isUpdating,
                                                        },
                                                    }}
                                                    onChange={onChangeAnnonce}
                                                />
                                            </Grid>

                                            <Grid item lg={12} sm={12} xs={12} style={{ marginBottom: '10px' }}>
                                                {errorMessages && (
                                                    <div className={classes.errors}>
                                                        <Typography>
                                                            <Error />
                                                            <br />
                                                            <span>{errorMessages}</span>
                                                        </Typography>
                                                    </div>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        item
                                        lg={3}
                                        sm={12}
                                        className={classes.photosContainer}
                                    >
                                        <div>
                                            {!previewPhotos.length && (
                                                <h3>
                                                    {t("propriete.labels.aucunePhoto")}
                                                </h3>
                                            )}
                                            {previewPhotos.length && (
                                                <PreviewPhotos
                                                    photos={previewPhotos}
                                                    isUpdating={isUpdating}
                                                    idProperty={property._id || ""}
                                                    onDeletePhoto={onDeletePhoto}
                                                />
                                            )}
                                        </div>
                                        <div>
                                            <UploadPhotos
                                                handleChangePhotos={onChangePhoto}
                                                isUpdating={!isUpdating}
                                                selectedPhotos={newPhotos}
                                            />
                                        </div>

                                        <div
                                            className={
                                                classes.updateInfosButtonsContainer
                                            }
                                        >
                                            <Button
                                                className={classes.updateButton}
                                                onClick={
                                                    isUpdating
                                                        ? cancelUpdatingForm
                                                        : triggerUpdatingForm
                                                }
                                            >
                                                {isUpdating
                                                    ? `${t(
                                                        "propriete.labels.annuler-la-modification"
                                                    )}`
                                                    : `${t(
                                                        "propriete.labels.modifier"
                                                    )}`}
                                            </Button>

                                            {isUpdating && (
                                                <Button
                                                    size="small"
                                                    type="submit"
                                                    className={classes.button}
                                                    endIcon={loading ? <Spin /> : null}
                                                    disabled={loading}
                                                >
                                                    {t("propriete.buttonSave")}
                                                </Button>
                                            )}
                                            <Grid item lg={12} sm={12} xs={12} style={{ marginBottom: '10px', marginTop: '15px' }}>
                                                {errorMessages && (
                                                    <div className={classes.errors}>
                                                        <Typography>
                                                            <Error />
                                                            <br />
                                                            <span>{errorMessages}</span>
                                                        </Typography>
                                                    </div>
                                                )}
                                            </Grid>
                                            
                                        </div>
                                    </Grid>
                               
                            </form>
                        )}
                        <AfriqSnackbar
                            {...snackValues}
                            handleClose={handleCloseSnackbar}
                        />
                    </div>
                </>
            )}       
        </>
    );
};
